webpackJsonp([1],{

/***/ "/vj7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',
  metaInfo: {
    title: 'About'
  },
  components: {
    'main-menu': __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Slide"]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['people', 'partners', 'settings']),
  data: function data() {
    return {
      msg: 'ABOUT',
      activeItem: -1
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('LOAD_PEOPLE_LIST');
    this.$store.dispatch('LOAD_PARTNERS_LIST');
  },

  methods: {
    openCV: function openCV(index) {
      console.log(index);
      this.activeItem = this.activeItem === index ? null : index;
    },
    closeCV: function closeCV() {
      this.activeItem = -1;
    }
  }
});

/***/ }),

/***/ "03+3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/drifter-tile-instrument.c9d6b0f.jpg";

/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MARKERICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OBJSORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARRAYSORT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);


var OBJSORT = function OBJSORT(a, b) {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
};

var ARRAYSORT = function ARRAYSORT(a, b) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

var MARKERICON = function MARKERICON(properties) {
  return __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.divIcon({
    html: '<div class="' + properties.selected + ' ' + properties.hidden + '"></div>',
    iconSize: [25, 24],
    iconAnchor: [12, 12], // relativo iconSize
    popupAnchor: [-5, -30],
    shadowSize: [0, 0],
    className: 'marker ' + properties.type + ' ' + properties.selected + ' ' + properties.hidden + '  status-' + properties.status.toLowerCase()
  });
};



/***/ }),

/***/ "6Jki":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6gDw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "73EO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"data"},[_c('header',{staticClass:"header"},[_c('main-menu')],1),_c('section',{staticClass:"section"},[_c('div',{staticClass:"actions-map"},[_c('button',{staticClass:"search",class:{ open: _vm.statusPanel },on:{"click":function($event){_vm.togglePanel()}}}),_c('button',{staticClass:"flyTo zoomIn btn-map",on:{"click":function($event){_vm.zoomIn()}}}),_c('button',{staticClass:"flyTo zoomOut btn-map",on:{"click":function($event){_vm.zoomOut()}}}),_c('button',{staticClass:"flyTo home btn-map",on:{"click":function($event){_vm.flyTo()}}})]),_c('div',{staticClass:"search-panel",class:{ open: _vm.statusPanel }},[_c('h1',[_vm._v("search by:")]),_c('vue-scrollbar',{ref:"scrollbar",staticClass:"form--wrapp"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.filterSearch($event)}}},[_c('div',{staticClass:"type"},[_c('label',[_vm._v("Instrument Type")]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapFilters.type),expression:"mapFilters.type"}],attrs:{"type":"checkbox","name":"drifters","id":"typeDrifters","value":"drifter"},domProps:{"checked":Array.isArray(_vm.mapFilters.type)?_vm._i(_vm.mapFilters.type,"drifter")>-1:(_vm.mapFilters.type)},on:{"change":[function($event){var $$a=_vm.mapFilters.type,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="drifter",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.mapFilters.type=$$a.concat([$$v]))}else{$$i>-1&&(_vm.mapFilters.type=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.mapFilters, "type", $$c)}},_vm.filterType]}}),_c('label',{attrs:{"for":"typeDrifters"}},[_vm._v("drifters"),_c('span',{staticClass:"checkmark"})])]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapFilters.type),expression:"mapFilters.type"}],attrs:{"type":"checkbox","name":"float","value":"float","id":"typeFloats"},domProps:{"checked":Array.isArray(_vm.mapFilters.type)?_vm._i(_vm.mapFilters.type,"float")>-1:(_vm.mapFilters.type)},on:{"change":[function($event){var $$a=_vm.mapFilters.type,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="float",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.mapFilters.type=$$a.concat([$$v]))}else{$$i>-1&&(_vm.mapFilters.type=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.mapFilters, "type", $$c)}},_vm.filterType]}}),_c('label',{attrs:{"for":"typeFloats"}},[_vm._v("float"),_c('span',{staticClass:"checkmark"})])]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapFilters.type),expression:"mapFilters.type"}],attrs:{"type":"checkbox","name":"gliders","value":"glider","id":"typeGliders"},domProps:{"checked":Array.isArray(_vm.mapFilters.type)?_vm._i(_vm.mapFilters.type,"glider")>-1:(_vm.mapFilters.type)},on:{"change":[function($event){var $$a=_vm.mapFilters.type,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="glider",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.mapFilters.type=$$a.concat([$$v]))}else{$$i>-1&&(_vm.mapFilters.type=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.mapFilters, "type", $$c)}},_vm.filterType]}}),_c('label',{attrs:{"for":"typeGliders"}},[_vm._v("gliders"),_c('span',{staticClass:"checkmark"})])])]),_c('div',{staticClass:"location"},[_c('label',[_vm._v("location")]),_c('v-select',{ref:"locationsSelect",attrs:{"options":_vm.locations,"searchable":false},on:{"input":_vm.filterLocation},model:{value:(_vm.defaultLoc),callback:function ($$v) {_vm.defaultLoc=$$v},expression:"defaultLoc"}})],1),_c('div',{staticClass:"project"},[_c('label',[_vm._v("project name")]),_c('v-select',{ref:"projectsSelect",attrs:{"options":_vm.projects},on:{"input":_vm.filterProjects},model:{value:(_vm.prjSelected),callback:function ($$v) {_vm.prjSelected=$$v},expression:"prjSelected"}})],1),(this.mapFilters.project)?_c('div',{staticClass:"project deploy"},[_c('div',{staticClass:"field-deploy"},[_c('label',[_vm._v("Project Deploy")]),_c('v-select',{ref:"projectsDeploy",attrs:{"options":_vm.deploy},on:{"input":_vm.filterProjectsDeploy},model:{value:(_vm.deploySelected),callback:function ($$v) {_vm.deploySelected=$$v},expression:"deploySelected"}})],1)]):_vm._e(),_c('div',{staticClass:"project id"},[_c('label',[_vm._v("Instrument Id")]),_c('v-select',{ref:"typeBoa",attrs:{"disabled":!_vm.loadedBoe,"options":['WMO', 'IMEI', 'ID'],"searchable":false},on:{"input":_vm.typeIdBoa},model:{value:(_vm.typeInstrument),callback:function ($$v) {_vm.typeInstrument=$$v},expression:"typeInstrument"}}),(_vm.typeId === 'WMO')?_c('v-select',{ref:"wmo",attrs:{"disabled":!_vm.loadedBoe,"multiple":"multiple","options":_vm.wmo},on:{"input":_vm.filterBoa},model:{value:(_vm.boeSelected),callback:function ($$v) {_vm.boeSelected=$$v},expression:"boeSelected"}}):_vm._e(),(_vm.typeId === 'IMEI')?_c('v-select',{ref:"imei",attrs:{"disabled":!_vm.loadedBoe,"multiple":"multiple","options":_vm.imei},on:{"input":_vm.filterBoa},model:{value:(_vm.boeSelected),callback:function ($$v) {_vm.boeSelected=$$v},expression:"boeSelected"}}):_vm._e(),(_vm.typeId === 'ID')?_c('v-select',{ref:"boeId",attrs:{"disabled":!_vm.loadedBoe,"multiple":"multiple","options":_vm.idBoe},on:{"input":_vm.filterBoa},model:{value:(_vm.boeSelected),callback:function ($$v) {_vm.boeSelected=$$v},expression:"boeSelected"}}):_vm._e()],1),_c('div',{staticClass:"project"},[_c('label',[_vm._v("nationality")]),_c('v-select',{ref:"nationalitySelect",attrs:{"disabled":!_vm.loadedBoe,"options":_vm.nationality},on:{"input":_vm.filterNationality},model:{value:(_vm.nationalitySelected),callback:function ($$v) {_vm.nationalitySelected=$$v},expression:"nationalitySelected"}})],1),_c('div',{staticClass:"period"},[_c('label',[_vm._v("period")]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.period),expression:"period"}],attrs:{"type":"radio","id":"last-week","value":"last-week"},domProps:{"checked":_vm._q(_vm.period,"last-week")},on:{"change":[function($event){_vm.period="last-week"},_vm.lastWeek]}}),_c('label',{attrs:{"for":"last-week"}},[_vm._v("last week"),_c('span',{staticClass:"checkmark radio"})])]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.period),expression:"period"}],attrs:{"type":"radio","id":"last-month","value":"last-month"},domProps:{"checked":_vm._q(_vm.period,"last-month")},on:{"change":[function($event){_vm.period="last-month"},_vm.lastMonth]}}),_c('label',{attrs:{"for":"last-month"}},[_vm._v("last month"),_c('span',{staticClass:"checkmark radio"})])]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.period),expression:"period"}],attrs:{"type":"radio","id":"this-year","value":"this-year"},domProps:{"checked":_vm._q(_vm.period,"this-year")},on:{"change":[function($event){_vm.period="this-year"},_vm.lastYear]}}),_c('label',{attrs:{"for":"this-year"}},[_vm._v("last year"),_c('span',{staticClass:"checkmark radio"})])])]),_c('div',{staticClass:"from-to"},[_c('div',[_c('label',[_vm._v("from")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapFilters.date_from),expression:"mapFilters.date_from"}],attrs:{"type":"date","name":"dateFrom","id":"dateFrom"},domProps:{"value":(_vm.mapFilters.date_from)},on:{"change":_vm.filterDateFrom,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mapFilters, "date_from", $event.target.value)}}})]),_c('div',[_c('label',[_vm._v("to")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapFilters.date_to),expression:"mapFilters.date_to"}],attrs:{"type":"date","name":"dateTo","id":"dateTo"},domProps:{"value":(_vm.mapFilters.date_to)},on:{"change":_vm.filterDateTo,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mapFilters, "date_to", $event.target.value)}}})])]),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"numeroboe"},[_vm._v("Total Instruments:"),(_vm.loadedBoe)?_c('span',[_vm._v(" "+_vm._s(_vm.boeSearchCount))]):_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_c('div',{staticClass:"double-bounce2"})])]),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"reset-action search-action",attrs:{"type":"button"},on:{"click":function($event){_vm.filterReset()}}},[_vm._v("Reset")]),_c('button',{staticClass:"search-action search",attrs:{"disabled":_vm.disableSearch()}},[_vm._v("view on map")])])])])])],1),_c('multipane',{staticClass:"horizontal-panes",attrs:{"layout":"horizontal"},on:{"paneResizeStop":_vm.paneresizestop}},[_c('div',{staticClass:"pane",class:{ full: _vm.statusPanel },style:({ height: '60%', maxHeight: 'calc(100% - 25px' }),attrs:{"id":"map"}},[_c('v-map',{ref:"map",attrs:{"zoom":_vm.zoom,"minZoom":_vm.minZoom,"maxZoom":_vm.maxZoom,"center":_vm.center,"bounds":_vm.bounds},on:{"l-ready":_vm.onMapReady}},[(_vm.markers)?_c('v-geojson-layer',{ref:"markers",attrs:{"geojson":_vm.markers,"options":_vm.markersOptions}}):_vm._e(),(_vm.trajectories)?_c('v-geojson-layer',{ref:"trajectories",attrs:{"geojson":_vm.trajectories,"options":_vm.trajectoriesOptions}}):_vm._e()],1)],1),(!_vm.locationsBox)?_c('multipane-resizer'):_vm._e(),_c('div',{staticClass:"table-list"},[_c('div',{staticClass:"controls columns"},[_c('ul',{staticClass:"metadata column"},[_c('li',{staticClass:"nome-progetto"},[_vm._v(_vm._s(_vm.tableCaption)),_c('span',[_vm._v(" "+_vm._s(_vm.boeCount))]),_vm._v(" instruments"),(this.instrumentSelected.label)?_c('span',[_vm._v("  model "+_vm._s(this.instrumentSelected.label)+"    ")]):_c('span',[_vm._v("  ")])]),_c('li',[_c('span',[_vm._v("from  "+_vm._s(_vm._f("ddmmyyyy")(_vm.fromSelect))+" - to "+_vm._s(_vm._f("ddmmyyyy")(_vm.toSelect)))])])]),_c('ul',{staticClass:"toggleTable column"},[_c('li',{class:{ active: !_vm.tableView },on:{"click":_vm.tableType}},[_vm._v("localization")]),_c('li',{class:{ active: _vm.tableView },on:{"click":_vm.tableType}},[_vm._v("specification")])])]),(_vm.loadedTable)?_c('div',{staticClass:"box"},[(_vm.boe.length && !_vm.tableView)?_c('v-client-table',{ref:"table",staticClass:"table-one",attrs:{"data":_vm.boe,"columns":_vm.table.columns,"options":_vm.table.options},scopedSlots:_vm._u([{key:"select",fn:function(props){return _c('i',{staticClass:"show",on:{"click":function($event){_vm.viewMarker($event, props.row.id_boa)}}},[_c('span',[_vm._v("go to")])])}},{key:"h__hide",fn:function(props){return _c('div',{staticClass:"form-all"},[_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){_vm.hideAll($event)}}}),_c('div',[_vm._v("Hide")])])}},{key:"hide",fn:function(props){return _c('i',{staticClass:"hidden"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hiddenId),expression:"hiddenId"}],attrs:{"type":"checkbox","id":("hidden-" + (props.row.id_boa))},domProps:{"value":props.row.id_boa,"checked":Array.isArray(_vm.hiddenId)?_vm._i(_vm.hiddenId,props.row.id_boa)>-1:(_vm.hiddenId)},on:{"click":function($event){_vm.hiddenMarker($event, props.row.id_boa)},"change":function($event){var $$a=_vm.hiddenId,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=props.row.id_boa,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hiddenId=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hiddenId=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hiddenId=$$c}}}}),_c('label',{staticClass:"hidden",attrs:{"for":("hidden-" + (props.row.id_boa))}})])}},{key:"h__trj",fn:function(props){return _c('div',{staticClass:"form-all"},[_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){_vm.trjAll($event)}}}),_c('div',[_vm._v("tracks")])])}},{key:"trj",fn:function(props){return _c('i',{},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trjId),expression:"trjId"}],attrs:{"type":"checkbox","id":("trj-" + (props.row.id_boa))},domProps:{"value":props.row.id_boa,"checked":Array.isArray(_vm.trjId)?_vm._i(_vm.trjId,props.row.id_boa)>-1:(_vm.trjId)},on:{"click":function($event){_vm.trjMarker($event, props.row.type, props.row.id_boa)},"change":function($event){var $$a=_vm.trjId,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=props.row.id_boa,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.trjId=$$a.concat([$$v]))}else{$$i>-1&&(_vm.trjId=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.trjId=$$c}}}}),_c('label',{staticClass:"trj",attrs:{"for":("trj-" + (props.row.id_boa))}})])}},{key:"type",fn:function(props){return _c('i',{class:props.row.type},[_c('span',[_vm._v(_vm._s(props.row.type))])])}},{key:"h__kml",fn:function(props){return _c('div',{staticClass:"form-all"},[_c('i',{staticClass:"kml kml--all",on:{"click":_vm.getAllKml}}),_c('div',[_vm._v("kml")])])}},{key:"kml",fn:function(props){return _c('i',{staticClass:"kml",on:{"click":function($event){_vm.getKml($event, props.row.id_boa, props.row.type)}}})}},{key:"status",fn:function(props){return _c('i',{class:("status-" + (props.row.status))},[_c('span',[_vm._v(_vm._s(props.row.status))])])}},{key:"wmo",fn:function(props){return _c('span',{domProps:{"innerHTML":_vm._s(props.row.wmo)}})}},{key:"deployment_time",fn:function(props){return _c('span',{},[_vm._v(_vm._s(_vm._f("ddmmyyyyhmm")(props.row.deployment_time)))])}},{key:"transmission_last_date",fn:function(props){return _c('span',{},[_vm._v(_vm._s(_vm._f("ddmmyyyyhmm")(props.row.transmission_last_date)))])}}])}):_vm._e(),(_vm.boe.length && _vm.tableView)?_c('v-client-table',{ref:"tableBonus",staticClass:"table-bonus",attrs:{"data":_vm.boe,"columns":_vm.table.columnsbis,"options":_vm.table.options},scopedSlots:_vm._u([{key:"select",fn:function(props){return _c('i',{staticClass:"show",on:{"click":function($event){_vm.viewMarker($event, props.row.id_boa)}}},[_c('span',[_vm._v("go to")])])}},{key:"h__hide",fn:function(props){return _c('div',{staticClass:"form-all"},[_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){_vm.hideAll($event)}}}),_c('div',[_vm._v("Hide")])])}},{key:"hide",fn:function(props){return _c('i',{staticClass:"hidden"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hiddenId),expression:"hiddenId"}],attrs:{"type":"checkbox","id":("hidden-" + (props.row.id_boa))},domProps:{"value":props.row.id_boa,"checked":Array.isArray(_vm.hiddenId)?_vm._i(_vm.hiddenId,props.row.id_boa)>-1:(_vm.hiddenId)},on:{"click":function($event){_vm.hiddenMarker($event, props.row.id_boa)},"change":function($event){var $$a=_vm.hiddenId,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=props.row.id_boa,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hiddenId=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hiddenId=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hiddenId=$$c}}}}),_c('label',{staticClass:"hidden",attrs:{"for":("hidden-" + (props.row.id_boa))}})])}},{key:"h__trj",fn:function(props){return _c('div',{staticClass:"form-all"},[_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){_vm.trjAll($event)}}}),_c('div',[_vm._v("path")])])}},{key:"trj",fn:function(props){return _c('i',{},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trjId),expression:"trjId"}],attrs:{"type":"checkbox","id":("trj-" + (props.row.id_boa))},domProps:{"value":props.row.id_boa,"checked":Array.isArray(_vm.trjId)?_vm._i(_vm.trjId,props.row.id_boa)>-1:(_vm.trjId)},on:{"click":function($event){_vm.trjMarker($event, props.row.type, props.row.id_boa)},"change":function($event){var $$a=_vm.trjId,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=props.row.id_boa,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.trjId=$$a.concat([$$v]))}else{$$i>-1&&(_vm.trjId=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.trjId=$$c}}}}),_c('label',{staticClass:"trj",attrs:{"for":("trj-" + (props.row.id_boa))}})])}},{key:"type",fn:function(props){return _c('i',{class:props.row.type},[_c('span',[_vm._v(_vm._s(props.row.type))])])}},{key:"h__kml",fn:function(props){return _c('div',{staticClass:"form-all"},[_c('i',{staticClass:"kml kml--all",on:{"click":_vm.getAllKml}}),_c('div',[_vm._v("kml")])])}},{key:"kml",fn:function(props){return _c('i',{staticClass:"kml",on:{"click":function($event){_vm.getKml($event, props.row.id_boa, props.row.type)}}})}},{key:"status",fn:function(props){return _c('i',{class:("status-" + (props.row.status))},[_c('span',[_vm._v(_vm._s(props.row.status))])])}},{key:"wmo",fn:function(props){return _c('div',{domProps:{"innerHTML":_vm._s(props.row.wmo)}})}},{key:"deployment_time",fn:function(props){return _c('span',{},[_vm._v(_vm._s(_vm._f("ddmmyyyyhmm")(props.row.deployment_time)))])}},{key:"transmission_last_date",fn:function(props){return _c('span',{},[_vm._v(_vm._s(_vm._f("ddmmyyyyhmm")(props.row.transmission_last_date)))])}}])}):_vm._e()],1):_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_c('div',{staticClass:"double-bounce2"})])])],1),(_vm.locationsBox)?_c('div',{staticClass:"box-overlay"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("OUR DATA"),(_vm.prjLocator.active)?_c('span',[_vm._v(" for "+_vm._s(_vm.tableCaption))]):_vm._e()]),_c('div',{staticClass:"intro",domProps:{"innerHTML":_vm._s(_vm.settings.sections.data.intro)}}),_c('h2',[_vm._v("select the area")]),_c('br'),_c('div',{staticClass:"tiles"},[_c('a',{staticClass:"tile",class:{empty:_vm.mediterraneanSea.sum < 1},on:{"click":function($event){_vm.loadLocator(5, _vm.mediterraneanSea.sum)}}},[(!_vm.prjLocator.active)?_c('h2',[_vm._v("Last 30 days data")]):_vm._e(),_c('div',[_c('p',[_vm._v(_vm._s(_vm.mediterraneanSea.sum)),_c('span',[_vm._v("Total Instruments")])]),_c('h1',[_vm._v(_vm._s(_vm.mediterraneanSea.area))]),(_vm.mediterraneanSea.sum > 0)?_c('a',[_c('span'),_vm._v("explore area")]):_vm._e()])]),_c('a',{staticClass:"tile",on:{"click":function($event){_vm.loadLocator(18, _vm.blackSea.sum)}}},[(!_vm.prjLocator.active)?_c('h2',[_vm._v("Last 30 days data")]):_vm._e(),_c('div',[_c('p',[_vm._v(_vm._s(_vm.blackSea.sum)),_c('span',[_vm._v("Total Instruments")])]),_c('h1',[_vm._v(_vm._s(_vm.blackSea.area))]),(_vm.blackSea.sum > 0)?_c('a',[_c('span'),_vm._v("explore area")]):_vm._e()])]),_c('a',{staticClass:"tile",class:{empty:_vm.atlanticOcean.sum < 1},on:{"click":function($event){_vm.loadLocator(2, _vm.atlanticOcean.sum)}}},[(!_vm.prjLocator.active)?_c('h2',[_vm._v("Last 30 days data")]):_vm._e(),_c('div',[_c('p',[_vm._v(_vm._s(_vm.atlanticOcean.sum)),_c('span',[_vm._v("Total Instruments")])]),_c('h1',[_vm._v(_vm._s(_vm.atlanticOcean.area))]),(_vm.atlanticOcean.sum > 0)?_c('a',[_c('span'),_vm._v("explore area")]):_vm._e()])]),_c('a',{staticClass:"tile",on:{"click":function($event){_vm.loadLocator(19, _vm.antarcticArea.sum)}}},[(!_vm.prjLocator.active)?_c('h2',[_vm._v("Last 30 days data")]):_vm._e(),_c('div',[_c('p',[_vm._v(_vm._s(_vm.antarcticArea.sum)),_c('span',[_vm._v("Total Instruments")])]),_c('h1',[_vm._v(_vm._s(_vm.antarcticArea.area))]),(_vm.antarcticArea.sum > 0)?_c('a',[_c('span'),_vm._v("explore area")]):_vm._e()])])])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9KCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.home_data.boe_per_oceano_last_month)?_c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',{attrs:{"exclude":['home', 'projects', 'project', 'dataView']}},[_c('router-view',{staticClass:"wrapper"})],1)],1),_c('div',{staticClass:"black-container"}),(_vm.settings)?_c('footer',{staticClass:"footer"},[_c('ul',_vm._l((_vm.settings.mainmenu),function(item){return _c('li',{class:{ 'navbar-item': item.nodes, 'has-dropdown': item.nodes, 'is-hoverable': item.nodes }},[_c('router-link',{staticClass:"navbar-item",class:{ 'navbar-link': item.nodes},attrs:{"exact":"exact","to":item.slug,"active-class":"is-active"}},[_vm._v(_vm._s(item.title))]),(item.nodes)?_c('ul',{staticClass:"navbar-dropdown is-boxed"},_vm._l((item.nodes),function(subitem){return _c('li',[_c('router-link',{staticClass:"navbar-item",attrs:{"to":subitem.slug,"active-class":"is-active"}},[_vm._v(_vm._s(subitem.title))])],1)})):_vm._e()],1)})),_c('div',{domProps:{"innerHTML":_vm._s(_vm.settings.footer)}})]):_vm._e()],1):_c('div',{staticClass:"loading"},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_c('div',{staticClass:"double-bounce2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BLQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('nav',{staticClass:"navbar",class:{ minimized: _vm.isMinimized }},[_c('div',{staticClass:"div container"},[_c('div',{staticClass:"navbar-brand"},[_vm._m(0),_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/","exact":"exact"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("VyZF"),"alt":"logo","width":"auto","height":"43"}})])],1),_c('div',{staticClass:"navbar-menu"},[_c('ul',{staticClass:"navbar-end"},_vm._l((_vm.settings.mainmenu),function(item){return _c('li',{class:{ 'navbar-item': item.nodes, 'has-dropdown': item.nodes, 'is-hoverable': item.nodes }},[(item.title === 'Instruments')?_c('router-link',{staticClass:"navbar-item",class:{ 'navbar-link': item.nodes, 'is-active': _vm.isActive},attrs:{"exact":"exact","to":item.slug,"active-class":"is-active"}},[_vm._v(_vm._s(item.title))]):_c('router-link',{staticClass:"navbar-item",class:[{'navbar-link': item.nodes}, item.slug.substring(1)],attrs:{"exact":"exact","to":item.slug,"active-class":"is-active"}},[_vm._v(_vm._s(item.title))]),(item.nodes)?_c('ul',{staticClass:"navbar-dropdown is-boxed"},_vm._l((item.nodes),function(subitem){return _c('li',[_c('router-link',{staticClass:"navbar-item",attrs:{"to":subitem.slug,"active-class":"is-active"}},[_vm._v(_vm._s(subitem.title))])],1)})):_vm._e()],1)}))]),_c('div',{staticClass:"menu-button",on:{"click":_vm.toggleMenu}},[_c('span'),_c('span'),_c('span')])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item",attrs:{"href":"//www.ogs.trieste.it/","title":"OGS Website"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("CZmw"),"alt":"logo","width":"auto","height":"54"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CP3g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('main',{staticClass:"about"},[_c('header',{staticClass:"header"},[_c('main-menu'),_c('carousel',{attrs:{"perPage":1,"autoplay":true,"autoplayHoverPause":true,"loop":true,"autoplayTimeout":6000,"paginationColor":"#f8f8f8","paginationActiveColor":"#5477a3"}},_vm._l((_vm.settings.sections.about.carousel),function(slide,index){return _c('slide',{key:index,style:(("background-image:url(" + slide + ")"))})}))],1),_c('section',{staticClass:"section"},[_c('div',{staticClass:"intro container"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.settings.sections.about.title))]),_c('p',[_vm._v(_vm._s(_vm.settings.sections.about.description))])]),_c('div',{staticClass:"wrapper-people"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("people")]),_c('div',{staticClass:"columns people"},_vm._l((_vm.people),function(item,index){return _c('div',{staticClass:"column",class:{close: index !== _vm.activeItem}},[_c('div',{staticClass:"picture"},[(item.foto)?_c('img',{attrs:{"src":item.foto,"width":"264","height":"150","alt":"foto"}}):_c('img',{attrs:{"src":"static/img/placeholder-people.png","width":"264","height":"150","alt":"foto"}})]),_c('h2',[_vm._v(_vm._s(item.nome)+" "+_vm._s(item.cognome))]),_c('h3',[_vm._v(_vm._s(item.tipo))]),(item.email_to)?_c('h4',{staticClass:"mail"},[_vm._v(_vm._s(item.email_to))]):_vm._e(),_c('h4',{staticClass:"phone"},[_vm._v(_vm._s(item.tel))]),_c('div',{staticClass:"curriculum-toggle",on:{"click":function($event){_vm.openCV(index)}}},[_c('span'),_c('span')]),_c('div',{staticClass:"cv"},[_c('p',[_vm._v(_vm._s(item.cv))]),(item.www)?_c('a',{attrs:{"href":item.www,"target":"new"}},[_vm._v("See Curriculum")]):_vm._e()])])}))])]),_c('div',{staticClass:"wrapper-partners"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("main sponsors")]),(_vm.settings.sections.about.partners)?_c('h2',{domProps:{"innerHTML":_vm._s(_vm.settings.sections.about.partners)}}):_vm._e(),_c('div',{staticClass:"columns partners"},_vm._l((_vm.partners),function(partner){return _c('a',{staticClass:"logo column",attrs:{"href":partner.link,"target":"_blank"}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":partner.logo,"width":"72","height":"96"}})]),_c('div',{staticClass:"partner-name"},[_c('p',[_vm._v(_vm._s(partner.nome))])])])}))])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CVjR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'publications',
  metaInfo: {
    title: 'Publications'
  },
  components: {
    'main-menu': __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__["a" /* default */],
    'v-select': __WEBPACK_IMPORTED_MODULE_1_vue_select___default.a
  },
  computed: {
    settings: function settings() {
      return this.$store.state.settings;
    },
    publications: function publications() {
      return this.$store.getters.publications;
    },
    years: function years() {
      var year = [];
      this.$store.getters.publicationsFilters.forEach(function (y) {
        if (!year.includes(y.year) && y.year !== null) {
          year.push(y.year);
        }
      });
      return year;
    },
    type: function type() {
      var type = [];
      this.$store.getters.publicationsFilters.forEach(function (p) {
        if (!type.includes(p.tipo)) {
          type.push(p.tipo);
        }
      });
      return type;
    }
  },
  data: function data() {
    return {
      yearsAll: { value: null, id: null, label: 'All' },
      filtersOpen: false,
      filters: {
        type: null,
        year: null,
        author: null,
        title: null
      }
    };
  },

  methods: {
    openFilters: function openFilters() {
      this.filtersOpen = !this.filtersOpen;
    },
    yearFilter: function yearFilter(year) {
      if (typeof year === 'string') {
        this.filters.year = year;
        this.updatePub();
      }
    },
    typeFilter: function typeFilter(type) {
      if (typeof type === 'string') {
        this.filters.type = type;
        this.updatePub();
      }
    },
    authorFilter: function authorFilter() {
      if (typeof this.filters.author === 'string') {
        this.updatePub();
      }
    },
    titleFilter: function titleFilter() {
      if (typeof this.filters.title === 'string') {
        this.updatePub();
      }
    },
    updatePub: function updatePub() {
      this.$store.commit('SET_PUB_FILTERS', {
        type: this.filters.type,
        year: this.filters.year,
        author: this.filters.author,
        title: this.filters.title
      });
    },
    resetFilters: function resetFilters() {
      this.filters.year = null;
      this.filters.author = null;
      this.filters.title = null;
      this.filters.type = null;
      this.yearsAll = { value: null, id: null, label: 'All' };
      this.updatePub();
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('LOAD_PUBLICATIONS_LIST');
  },
  beforeDestroy: function beforeDestroy() {
    this.filtersOpen = false;
  }
});

/***/ }),

/***/ "CWZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('main',{staticClass:"contacts"},[_c('header',{staticClass:"header"},[_c('main-menu'),_c('carousel',{attrs:{"perPage":1,"autoplay":true,"autoplayHoverPause":true,"loop":true,"autoplayTimeout":6000,"paginationColor":"#f8f8f8","paginationActiveColor":"#5477a3"}},_vm._l((_vm.settings.sections.contacts.carousel),function(slide,index){return _c('slide',{key:index,style:(("background-image:url(" + slide + ")"))})}))],1),_c('section',{staticClass:"section"},[_c('div',{staticClass:"intro container"},[_c('div',{staticClass:"contatti"},[_c('h1',[_vm._v("MAOS GROUP")]),_c('h4',[_vm._v(_vm._s(_vm.settings.sections.contacts.subtitle))]),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.settings.sections.contacts.location.address))]),_c('li',[_vm._v(_vm._s(_vm.settings.sections.contacts.location.phone))])]),_vm._l((_vm.settings.sections.contacts.administrative),function(item){return _c('div',{staticClass:"administrative-contacts"},[_c('h1',[_vm._v(_vm._s(item.title)+":")]),_c('ul',[_vm._l((item.people),function(people){return _c('li',{staticClass:"name"},[_vm._v(_vm._s(people.name))])}),_c('li',[_c('a',{attrs:{"href":("mailto:" + (_vm.settings.sections.contacts.admin.email)),"target":"new"}},[_vm._v(_vm._s(_vm.settings.sections.contacts.admin.email))])])],2)])})],2),_c('div',{staticClass:"referenti"},_vm._l((_vm.settings.sections.contacts.referents),function(item){return _c('div',[_c('h4',[_vm._v(_vm._s(item.title))]),_vm._l((item.people),function(people){return _c('ul',[_c('li',[_vm._v(_vm._s(people.name))]),_c('li',[_c('a',{attrs:{"href":("mailto:" + (people.email)),"target":"new"}},[_vm._v(_vm._s(people.email)),_c('span',[_vm._v(" // "+_vm._s(people.tel))])])])])})],2)}))]),_c('div',{staticClass:"map"},[_c('v-map',{ref:"map",attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":_vm.options}},[_c('v-tilelayer',{attrs:{"url":_vm.url}}),_c('v-geojson-layer',{attrs:{"geojson":_vm.geojson,"options":_vm.markers_options}})],1)],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CZmw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-ogs.d9347e3.png";

/***/ }),

/***/ "F3oK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('main',{staticClass:"projects"},[_c('header',{staticClass:"header"},[_c('main-menu')],1),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"intro"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.settings.sections.projects.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.settings.sections.projects.subtitle)}})]),_c('div',{staticClass:"filters",class:{open: _vm.filtersOpen}},[_c('p',{staticClass:"is-hidden-tablet",on:{"click":_vm.openFilters}},[_vm._v("Filter By"),(_vm.filtersOpen)?_c('span',[_vm._v("-")]):_c('span',[_vm._v("+")])]),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"year"},[_c('label',[_vm._v("year")]),_c('v-select',{attrs:{"value":_vm.defaultAll,"options":_vm.years,"on-change":_vm.yearProjects,"searchable":true},on:{"update:value":function($event){_vm.defaultAll=$event}}})],1),_c('div',{staticClass:"location"},[_c('label',[_vm._v("location")]),_c('v-select',{attrs:{"value":_vm.defaultAll,"options":_vm.locations,"on-change":_vm.locationProjects,"searchable":true},on:{"update:value":function($event){_vm.defaultAll=$event}}})],1),_c('form',{staticClass:"type"},[_c('label',[_vm._v("type")]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedType),expression:"checkedType"}],attrs:{"type":"checkbox","name":"drifters","id":"typeDrifters","value":"drifter"},domProps:{"checked":Array.isArray(_vm.checkedType)?_vm._i(_vm.checkedType,"drifter")>-1:(_vm.checkedType)},on:{"change":[function($event){var $$a=_vm.checkedType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="drifter",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedType=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedType=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedType=$$c}},_vm.typeProjects]}}),_vm._m(0)]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedType),expression:"checkedType"}],attrs:{"type":"checkbox","name":"float","value":"float","id":"typeFloats"},domProps:{"checked":Array.isArray(_vm.checkedType)?_vm._i(_vm.checkedType,"float")>-1:(_vm.checkedType)},on:{"change":[function($event){var $$a=_vm.checkedType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="float",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedType=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedType=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedType=$$c}},_vm.typeProjects]}}),_vm._m(1)]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedType),expression:"checkedType"}],attrs:{"type":"checkbox","name":"gliders","value":"glider","id":"typeGliders"},domProps:{"checked":Array.isArray(_vm.checkedType)?_vm._i(_vm.checkedType,"glider")>-1:(_vm.checkedType)},on:{"change":[function($event){var $$a=_vm.checkedType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="glider",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedType=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedType=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedType=$$c}},_vm.typeProjects]}}),_vm._m(2)])]),_c('form',{staticClass:"status"},[_c('label',[_vm._v("status")]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],attrs:{"type":"radio","id":"statusDead","value":"Closed"},domProps:{"checked":_vm._q(_vm.status,"Closed")},on:{"change":[function($event){_vm.status="Closed"},_vm.statusProjects]}}),_vm._m(3)]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],attrs:{"type":"radio","id":"statsuAlive","value":"Ongoing"},domProps:{"checked":_vm._q(_vm.status,"Ongoing")},on:{"change":[function($event){_vm.status="Ongoing"},_vm.statusProjects]}}),_vm._m(4)])]),_c('form',{staticClass:"actions"},[_c('button',{attrs:{"type":"button"},on:{"click":_vm.resetFilters}},[_vm._v("Reset")])])])])]),_c('div',[_c('div',{staticClass:"projects container"},[_c('h2',{staticClass:"subtitle"},[_vm._v("Latest Projects")]),_c('masonry',{attrs:{"cols":{default: 3, 1215: 2, 720: 1},"gutter":20}},_vm._l((_vm.projects),function(project,index){return _c('div',{key:("project-" + index),staticClass:"project"},[_c('div',[_c('h1',[_vm._v(_vm._s(project.name))]),_c('h3',_vm._l((project.location),function(location,index){return _c('span',{key:location.id},[_vm._v(_vm._s(location.name)),(index + 1 < project.location.length)?[_vm._v(" / ")]:_vm._e()],2)})),_c('ul',[_c('li',[_c('ul',[_c('li',[_vm._v("status")]),_c('li',[_vm._v(_vm._s(project.status))])]),_c('ul',{staticClass:"type"},[_c('li',[_vm._v("type")]),_c('li',{staticClass:"value"},_vm._l((project.type),function(type){return _c('span',[_vm._v(_vm._s(type.replace(/\w/, function (c) { return c.toUpperCase(); })))])}))]),_c('ul',[_c('li',[_vm._v("start date")]),_c('li',[_vm._v(_vm._s(project.date_start))])]),_c('ul',[_c('li',[_vm._v("end date")]),_c('li',[_vm._v(_vm._s(project.date_end || 'Not defined'))])])])]),(project.description)?_c('p',{domProps:{"innerHTML":_vm._s(project.description)}},[_vm._v("a")]):_vm._e(),_c('div',{staticClass:"buttons"},[_c('div',[_c('a',{on:{"click":function($event){_vm.viewMap(project)}}},[_vm._v("mappa")])]),_c('div',[_c('router-link',{attrs:{"to":("projects/" + (project.nome_www))}},[_vm._v("Project info")])],1)])])])}))],1)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"typeDrifters"}},[_vm._v("drifters"),_c('span',{staticClass:"checkmark"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"typeFloats"}},[_vm._v("float"),_c('span',{staticClass:"checkmark"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"typeGliders"}},[_vm._v("gliders"),_c('span',{staticClass:"checkmark"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"statusDead"}},[_vm._v("closed"),_c('span',{staticClass:"checkmark radio"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"statsuAlive"}},[_vm._v("ongoing"),_c('span',{staticClass:"checkmark radio"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fqc9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home-instrument-floats.395abed.jpg";

/***/ }),

/***/ "G0oW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('main',{staticClass:"publications"},[_c('header',{staticClass:"header"},[_c('main-menu')],1),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"intro"},[_c('h1',[_vm._v(_vm._s(_vm.settings.sections.publications.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.settings.sections.publications.subtitle)}}),_c('div',{staticClass:"notice",domProps:{"innerHTML":_vm._s(_vm.settings.sections.publications.notice)}})]),_c('div',{staticClass:"filters",class:{open: _vm.filtersOpen}},[_c('p',{staticClass:"is-hidden-tablet",on:{"click":_vm.openFilters}},[_vm._v("Filter By"),(_vm.filtersOpen)?_c('span',[_vm._v("-")]):_c('span',[_vm._v("+")])]),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"year"},[_c('label',[_vm._v("year")]),_c('v-select',{attrs:{"value":_vm.yearsAll,"options":_vm.years,"on-change":_vm.yearFilter,"searchable":true},on:{"update:value":function($event){_vm.yearsAll=$event}},model:{value:(_vm.yearsAll),callback:function ($$v) {_vm.yearsAll=$$v},expression:"yearsAll"}})],1),_c('div',{staticClass:"year"},[_c('label',[_vm._v("type")]),_c('v-select',{attrs:{"value":_vm.yearsAll,"options":_vm.type,"on-change":_vm.typeFilter,"searchable":true},on:{"update:value":function($event){_vm.yearsAll=$event}},model:{value:(_vm.yearsAll),callback:function ($$v) {_vm.yearsAll=$$v},expression:"yearsAll"}})],1),_c('div',{staticClass:"author"},[_c('label',[_vm._v("author")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.author),expression:"filters.author"}],staticClass:"form-text",domProps:{"value":(_vm.filters.author)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "author", $event.target.value)},_vm.authorFilter]}})]),_c('div',{staticClass:"title"},[_c('label',[_vm._v("title")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.title),expression:"filters.title"}],staticClass:"form-text",domProps:{"value":(_vm.filters.title)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "title", $event.target.value)},_vm.titleFilter]}})]),_c('form',{staticClass:"actions"},[_c('button',{attrs:{"type":"button"},on:{"click":_vm.resetFilters}},[_vm._v("Reset")])])])])]),_c('div',[_c('div',{staticClass:"container pubications"},_vm._l((_vm.publications),function(publication){return _c('div',{key:publication.id_report,staticClass:"row-item",class:("type-" + (publication.id_type_pub))},[(publication.url)?_c('div',[_c('a',{attrs:{"href":publication.url,"target":"new"}},[_vm._v(_vm._s(publication.titolo))])]):_c('div',[_vm._v(_vm._s(publication.titolo))]),_c('div',{staticClass:"author"},[_vm._v(_vm._s(publication.autori))]),_c('div',{staticClass:"meta"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(publication.data_pub))]),(publication.fonte)?_c('span',{staticClass:"fonte"},[_vm._v(" - "+_vm._s(publication.fonte))]):_vm._e()])])}))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GeAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__ = __webpack_require__("qycJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f07147_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__ = __webpack_require__("CWZY");
function injectStyle (ssrContext) {
  __webpack_require__("dxIX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49f07147"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f07147_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("0xDb");









__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  state: {
    settings: null,
    locationsBox: true,
    home_data: [],
    prjFilters: {
      date_range: null,
      id_oceano: null,
      type: [],
      status: null
    },
    mapFilters: {
      'location': null,
      'nationality': null,
      'type': ['drifter', 'float', 'glider'],
      'date_from': __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(3, 'days').format('YYYY-MM-DD'),
      'date_to': __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD'),
      'project': null,
      'id': null,
      'wmo': null,
      'imei': null,
      'instrument': null,
      'deployment': null
    },
    rengeMarkers: {},
    projects: [],
    project: {},
    people: [],
    partners: [],
    instruments: [],
    instrumentsFilter: [],
    locations: [],
    nameProjects: [],
    years: [],
    boe: [],
    publications: [],
    pubFilters: {
      year: null,
      author: null,
      title: null,
      type: null
    },
    boeSearch: [],
    boeList: [],
    mapGeojson: {
      'type': 'FeatureCollection',
      'features': []
    },
    markers: {
      'type': 'FeatureCollection',
      'features': []
    },
    home_markers: {
      'type': 'FeatureCollection',
      'features': []
    },
    trajectories: {
      'type': 'FeatureCollection',
      'features': []
    },
    loadedBoe: false,
    loadedTable: false,
    loadedMarkers: false
  },
  mutations: {
    SET_SETTINGS: function SET_SETTINGS(state, _ref) {
      var list = _ref.list;

      state.settings = list;
    },
    SET_HOME_DATA: function SET_HOME_DATA(state, _ref2) {
      var list = _ref2.list;

      state.home_data = list;
    },
    SET_HOME_MARKERS: function SET_HOME_MARKERS(state, _ref3) {
      var list = _ref3.list;

      if (list.features !== null) {
        state.home_markers = list;
      }
    },
    SET_PROJECT_LIST: function SET_PROJECT_LIST(state, _ref4) {
      var list = _ref4.list;

      state.projects = list;
    },
    SET_PROJECT: function SET_PROJECT(state, _ref5) {
      var prj = _ref5.prj;

      state.project = prj;
    },
    SET_FILTER_PROJECT_LIST: function SET_FILTER_PROJECT_LIST(state, _ref6) {
      var list = _ref6.list;

      state.nameProjects = list;
    },
    SET_PEOPLE_LIST: function SET_PEOPLE_LIST(state, _ref7) {
      var list = _ref7.list;

      state.people = list;
    },
    SET_PARTNERS_LIST: function SET_PARTNERS_LIST(state, _ref8) {
      var list = _ref8.list;

      state.partners = list;
    },
    SET_INSTRUMENTS_LIST: function SET_INSTRUMENTS_LIST(state, _ref9) {
      var list = _ref9.list;

      state.instruments = list;
    },
    SET_INSTRUMENTS_FILTER_LIST: function SET_INSTRUMENTS_FILTER_LIST(state, _ref10) {
      var list = _ref10.list;

      state.instrumentsFilter = list;
    },
    SET_YEARS_LIST: function SET_YEARS_LIST(state, _ref11) {
      var list = _ref11.list;

      state.years = list;
    },
    SET_LOCATIONS_LIST: function SET_LOCATIONS_LIST(state, _ref12) {
      var list = _ref12.list;

      state.locations = list;
    },
    SET_PUBLICATIONS_LIST: function SET_PUBLICATIONS_LIST(state, _ref13) {
      var list = _ref13.list;

      state.publications = list;
    },
    SET_PROJECT_YEAR_LIST: function SET_PROJECT_YEAR_LIST(state, year) {
      state.projects = state.projects.filter(function (project) {
        return project.date_range.includes(year);
      });
    },
    SET_PROJECT_LOCATION_LIST: function SET_PROJECT_LOCATION_LIST(state, location) {
      state.projects = state.projects.filter(function (project) {
        return project.location.name === location;
      });
    },
    SET_PROJECT_TYPE_LIST: function SET_PROJECT_TYPE_LIST(state, type) {
      state.projects = state.projects.filter(function (project) {
        return project.type.find(function (t) {
          return type.includes(t);
        });
      });
    },
    SET_RANGE_MARKERS: function SET_RANGE_MARKERS(state, _ref14) {
      var list = _ref14.list;

      state.rengeMarkers = list;
    },
    SET_MARKERS_LIST: function SET_MARKERS_LIST(state, _ref15) {
      var list = _ref15.list;

      state.markers = list;
    },
    SET_MAP_GEOJSON: function SET_MAP_GEOJSON(state, _ref16) {
      var day = _ref16.day;

      if (state.rengeMarkers[day] && state.rengeMarkers[day].hasOwnProperty('features')) {
        state.mapGeojson = state.rengeMarkers[day];
      } else {
        // is not geojson valid
        state.mapGeojson = {
          'type': 'FeatureCollection',
          'features': []
        };
      }
    },
    SET_BOE: function SET_BOE(state, _ref17) {
      var list = _ref17.list,
          type = _ref17.type;

      if (type === 'table') {
        state.boe = list;
      } else if (type === 'count') {
        state.boeSearch = list;
      } else if (type === 'list') {
        state.boeList = list;
        state.boeSearch = list;
      }
    },
    SET_PRJ_FILTERS: function SET_PRJ_FILTERS(state, _ref18) {
      var dateRange = _ref18.dateRange,
          idOceano = _ref18.idOceano,
          status = _ref18.status,
          type = _ref18.type;

      dateRange = dateRange === 'All' ? null : dateRange;
      state.prjFilters.date_range = dateRange || null;
      state.prjFilters.id_oceano = idOceano || null;
      state.prjFilters.status = status || null;
      state.prjFilters.type = type.length ? type : null;
    },
    SET_PUB_FILTERS: function SET_PUB_FILTERS(state, _ref19) {
      var type = _ref19.type,
          year = _ref19.year,
          author = _ref19.author,
          title = _ref19.title;

      type = type === 'All' ? null : type;
      year = year === 'All' ? null : year;
      state.pubFilters.year = year || null;
      state.pubFilters.type = type || null;
      state.pubFilters.author = author || null;
      state.pubFilters.title = title || null;
    },
    SET_MAP_FILTERS: function SET_MAP_FILTERS(state, _ref20) {
      var type = _ref20.type,
          location = _ref20.location,
          nationality = _ref20.nationality,
          dateFrom = _ref20.dateFrom,
          dateTo = _ref20.dateTo,
          project = _ref20.project,
          instrument = _ref20.instrument,
          deployment = _ref20.deployment;

      state.mapFilters.type = type || ['drifter', 'float', 'glider'];
      state.mapFilters.location = location || null;
      state.mapFilters.nationality = nationality || null;
      state.mapFilters.date_from = dateFrom || '';
      state.mapFilters.date_to = dateTo || null;
      state.mapFilters.project = project || null;
      state.mapFilters.instrument = instrument || null;
      state.mapFilters.deployment = deployment || null;
    },
    RESET_MAP_FILTERS: function RESET_MAP_FILTERS(state) {
      state.mapFilters = {
        'location': null,
        'nationality': null,
        'type': ['drifter', 'float', 'glider'],
        'date_from': '',
        'date_to': '',
        'project': null,
        'id': null,
        'wmo': null,
        'imei': null,
        'instrument': null,
        'deployment': null
      };
    },
    SET_LOCATION_BOX: function SET_LOCATION_BOX(state, status) {
      state.locationsBox = status;
    },
    SET_TRAJECTORY: function SET_TRAJECTORY(state, _ref21) {
      var list = _ref21.list;

      if (list.features.length) {
        state.trajectories.features.push(list.features[0]);
      }
    },
    UNSET_TRAJECTORY: function UNSET_TRAJECTORY(state, id) {
      state.trajectories.features = state.trajectories.features.filter(function (boa) {
        return boa.properties.id.toString() !== id.toString();
      });
    },
    CLEAR_TRAJECTORIES: function CLEAR_TRAJECTORIES(state) {
      state.trajectories.features = [];
    },
    SET_LOADED_BOE: function SET_LOADED_BOE(state, _ref22) {
      var loaded = _ref22.loaded,
          type = _ref22.type;

      if (type === 'table') {
        state.loadedTable = loaded;
      } else {
        state.loadedBoe = loaded;
      }
    },
    SET_LOADED_MARKERS: function SET_LOADED_MARKERS(state, value) {
      state.loadedMarkers = value;
    }
  },
  actions: {
    LOAD_SETTINGS: function LOAD_SETTINGS(_ref23) {
      var commit = _ref23.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('settings').then(function (response) {
        commit('SET_SETTINGS', { list: response.data.result });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_HOME_MARKERS: function LOAD_HOME_MARKERS(_ref24) {
      var commit = _ref24.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('markers?status=A').then(function (response) {
        commit('SET_HOME_MARKERS', { list: response.data });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_HOME_DATA: function LOAD_HOME_DATA(_ref25) {
      var commit = _ref25.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('home-data').then(function (response) {
        commit('SET_HOME_DATA', { list: response.data });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_PROJECT_LIST: function LOAD_PROJECT_LIST(_ref26) {
      var commit = _ref26.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('projects').then(function (response) {
        commit('SET_PROJECT_LIST', { list: response.data.result });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_PUBLICATIONS_LIST: function LOAD_PUBLICATIONS_LIST(_ref27) {
      var commit = _ref27.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('publications').then(function (response) {
        commit('SET_PUBLICATIONS_LIST', { list: response.data.result });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_PROJECT: function LOAD_PROJECT(_ref28, id) {
      var commit = _ref28.commit;

      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('projects/' + id).then(function (response) {
        commit('SET_PROJECT', { prj: response.data.result[0] });
        return response;
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_FILTER_PROJECT_LIST: function LOAD_FILTER_PROJECT_LIST(_ref29, filters) {
      var commit = _ref29.commit;

      // console.log('filters', filters)
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('projectslist?' + filters).then(function (response) {
        commit('SET_FILTER_PROJECT_LIST', { list: response.data.result });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_PEOPLE_LIST: function LOAD_PEOPLE_LIST(_ref30) {
      var commit = _ref30.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('people').then(function (response) {
        commit('SET_PEOPLE_LIST', { list: response.data.result });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_PARTNERS_LIST: function LOAD_PARTNERS_LIST(_ref31) {
      var commit = _ref31.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('partners').then(function (response) {
        commit('SET_PARTNERS_LIST', { list: response.data.result });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_INSTRUMENTS_LIST: function LOAD_INSTRUMENTS_LIST(_ref32, type) {
      var commit = _ref32.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('instruments?type=' + type).then(function (response) {
        commit('SET_INSTRUMENTS_LIST', { list: response.data });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_INSTRUMENTS_FILTER_LIST: function LOAD_INSTRUMENTS_FILTER_LIST(_ref33, filters) {
      var commit = _ref33.commit;

      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('typeList?' + filters).then(function (response) {
        commit('SET_INSTRUMENTS_FILTER_LIST', { list: response.data.result });
        return response;
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_YEARS_LIST: function LOAD_YEARS_LIST(_ref34) {
      var commit = _ref34.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('years').then(function (response) {
        commit('SET_YEARS_LIST', { list: response.data.result });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_LOCATIONS_LIST: function LOAD_LOCATIONS_LIST(_ref35) {
      var commit = _ref35.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('locations').then(function (response) {
        commit('SET_LOCATIONS_LIST', { list: response.data.result });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_PROJECT_YEAR_LIST: function LOAD_PROJECT_YEAR_LIST(_ref36, year) {
      var commit = _ref36.commit;

      commit('SET_PROJECT_YEAR_LIST', year);
    },
    LOAD_PROJECT_LOCATION_LIST: function LOAD_PROJECT_LOCATION_LIST(_ref37, location) {
      var commit = _ref37.commit;

      commit('SET_PROJECT_LOCATION_LIST', location);
    },
    LOAD_PROJECT_TYPE_LIST: function LOAD_PROJECT_TYPE_LIST(_ref38, location) {
      var commit = _ref38.commit;

      commit('SET_PROJECT_TYPE_LIST', location);
    },
    LOAD_BOE_LIST: function LOAD_BOE_LIST(_ref39, _ref40) {
      var commit = _ref39.commit;

      var _ref41 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref40, 2),
          filters = _ref41[0],
          value = _ref41[1];

      commit('SET_LOADED_BOE', { loaded: false, type: value });
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('boe?' + filters).then(function (response) {
        commit('SET_BOE', { list: response.data, type: value });
        commit('SET_LOADED_BOE', { loaded: true, type: value });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_RANGE_MARKERS: function LOAD_RANGE_MARKERS(_ref42, filters) {
      var commit = _ref42.commit;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('time-markers?' + filters).then(function (response) {
        commit('SET_MARKERS_LIST', { list: response.data });
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_MARKERS: function LOAD_MARKERS(_ref43, filters) {
      var commit = _ref43.commit;

      commit('SET_LOADED_MARKERS', false);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('time-markers-def?' + filters).then(function (response) {
        commit('SET_MARKERS_LIST', { list: response.data });
        commit('SET_LOADED_MARKERS', true);
      }, function (err) {
        console.log(err);
      });
    },
    LOAD_TRAJECTORY: function LOAD_TRAJECTORY(_ref44, filters) {
      var commit = _ref44.commit;

      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('trajectory?' + filters).then(function (response) {
        commit('SET_TRAJECTORY', { list: response.data });
        return response;
      }, function (err) {
        console.log(err);
      });
    }
  },
  getters: {
    markers: function markers(state) {
      return state.markers;
    },

    boe: function boe(state) {
      return state.boe;
    },

    instrumentsFilter: function instrumentsFilter(state) {
      return state.instrumentsFilter;
    },

    trajectory: function trajectory(state) {
      return state.trajectory;
    },

    selectLocations: function selectLocations(state) {
      return state.locations;
    },

    publicationsFilters: function publicationsFilters(state) {
      return state.publications;
    },

    publications: function publications(state) {
      // type, year, author, title, type
      return state.publications.filter(function (item) {
        return state.pubFilters.year === null ? true : item.year === state.pubFilters.year;
      }).filter(function (item) {
        return state.pubFilters.type === null ? true : item.tipo === state.pubFilters.type;
      }).filter(function (item) {
        return state.pubFilters.author === null ? true : item.autori === null ? false : item.autori.toLowerCase().includes(state.pubFilters.author.toLowerCase());
      }).filter(function (item) {
        return state.pubFilters.title === null ? true : item.titolo === null ? false : item.titolo.toLowerCase().includes(state.pubFilters.title.toLowerCase());
      });
    },

    selectProjects: function selectProjects(state) {
      state.nameProjects = state.nameProjects ? state.nameProjects : [];
      return state.nameProjects;
    },

    nationality: function nationality(state) {
      var selectBoe = [];
      state.boeList.map(function (x) {
        if (x.country_www !== null) {
          selectBoe.push(x.country_www.toString());
        }
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(selectBoe))).sort(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* ARRAYSORT */]);
    },

    wmo: function wmo(state) {
      var selectBoe = [];
      state.boeList.map(function (x) {
        if (x.wmo_nolink !== null) {
          selectBoe.push(x.wmo_nolink.toString());
        }
      });
      return selectBoe.sort(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* OBJSORT */]);
    },

    idBoe: function idBoe(state) {
      var selectBoe = [];
      state.boeList.map(function (x) {
        if (x.id_boa !== null) {
          selectBoe.push(x.id_boa.toString());
        }
      });
      return selectBoe.sort(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* OBJSORT */]);
    },

    imei: function imei(state) {
      var selectBoe = [];
      state.boeList.map(function (x) {
        if (x.imei !== null) {
          selectBoe.push(x.imei.toString());
        }
      });
      return selectBoe.sort(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* OBJSORT */]);
    },

    project: function project(state) {
      state.project.intro = state.project.html_description ? state.project.html_description[0].descrizione : '';

      state.project.scientifics = state.project.html_description ? state.project.html_description.filter(function (h) {
        return h.ordine !== 1;
      }) : [];

      if (state.project.charts) {
        state.project.charts.map(function (chart, index) {
          chart.is_active = index ? 0 : 1;
        });
      }
      return state.project;
    },

    projects: function projects(state) {
      return state.projects.filter(function (item) {
        return state.prjFilters.date_range === null ? true : item.date_range.includes(state.prjFilters.date_range);
      }).filter(function (item) {
        return state.prjFilters.status === null ? true : item.status === state.prjFilters.status;
      }).filter(function (item) {
        return state.prjFilters.id_oceano === null ? true : item.location.some(function (l) {
          return l.id === state.prjFilters.id_oceano;
        });
      }).filter(function (item) {
        return state.prjFilters.type === null ? true : item.type.some(function (a) {
          return state.prjFilters.type.some(function (m) {
            return a === m;
          });
        });
      });
    },

    boeCount: function boeCount(state) {
      return state.boe.length;
    },

    boeSearchCount: function boeSearchCount(state) {
      return state.boeSearch.length;
    },

    allmarkers: function allmarkers(state) {
      return state.markers;
    },

    instrument: function instrument(state, getters) {
      return function (id) {
        return state.instruments.filter(function (instrument) {
          return instrument.id_instrument === id;
        });
      };
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "KSaD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kw7C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kyoa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Publications_vue__ = __webpack_require__("CVjR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbfc88e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Publications_vue__ = __webpack_require__("G0oW");
function injectStyle (ssrContext) {
  __webpack_require__("KSaD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dbfc88e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Publications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbfc88e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Publications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e88a69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("9KCt");
function injectStyle (ssrContext) {
  __webpack_require__("6gDw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e88a69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_tables_2__ = __webpack_require__("e9ss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_masonry_css__ = __webpack_require__("G7ha");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_tables_2__["ClientTable"]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_masonry_css__["a" /* default */]);

// Set this to false to prevent the production tip on Vue startup.
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.devtools = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.debug = false;

// set baseUrl from app
// axios.defaults.baseURL = 'http://' + window.location.hostname + ':8080/static/api/'
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = 'https://maosapi.ogs.it/v0.1';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
  id: 'UA-2130807-49',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ "NPRs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gliders-tile-instrument.cc7e592.jpg";

/***/ }),

/***/ "PFnb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pm90":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home-instrument-drifters.f20e3b2.jpg";

/***/ }),

/***/ "R/qB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R1Vd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MainMenu_vue__ = __webpack_require__("x7p7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'projects',
  metaInfo: {
    title: 'Projects'
  },
  components: {
    'main-menu': __WEBPACK_IMPORTED_MODULE_4__components_MainMenu_vue__["a" /* default */],
    'v-select': __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    settings: 'settings',
    years: 'years'
  }), {
    locations: function locations() {
      return this.$store.getters.selectLocations;
    },
    projects: function projects() {
      return this.$store.getters.projects;
    }
  }),
  data: function data() {
    return {
      checkedType: [],
      filtersOpen: false,
      started: [],
      status: '',
      defaultAll: { value: null, id: null, label: 'ALL' },
      filters: {
        date_range: null,
        id_oceano: null,
        type: [],
        status: null
      }
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('LOAD_LOCATIONS_LIST');
    this.$store.dispatch('LOAD_YEARS_LIST');
    this.$store.dispatch('LOAD_PROJECT_LIST');
  },

  methods: {
    openFilters: function openFilters() {
      this.filtersOpen = !this.filtersOpen;
    },
    yearProjects: function yearProjects(year) {
      if (typeof year === 'string') {
        this.filters.date_range = year;
        this.updatePrj();
      }
    },
    locationProjects: function locationProjects(location) {
      this.filters.location = location.id;
      this.updatePrj();
    },
    statusProjects: function statusProjects() {
      this.filters.status = this.status;
      this.updatePrj();
    },
    typeProjects: function typeProjects() {
      this.filters.type = this.checkedType;
      this.updatePrj();
    },
    updatePrj: function updatePrj() {
      this.$store.commit('SET_PRJ_FILTERS', {
        dateRange: parseInt(this.filters.date_range, 10),
        idOceano: parseInt(this.filters.location, 10),
        status: this.filters.status,
        type: this.filters.type
      });
    },
    resetFilters: function resetFilters() {
      this.filters.date_range = null;
      this.filters.location = null;
      this.filters.status = null;
      this.filters.type = [];
      this.status = null;
      this.checkedType = [];
      this.status = '';
      this.defaultAll = { value: null, id: null, label: 'ALL' };
      this.updatePrj();
    },
    viewMap: function viewMap(prj) {
      var _this = this;

      this.$store.dispatch('LOAD_PROJECT', prj.id_project).then(function (response) {
        _this.$store.commit('SET_MAP_FILTERS', {
          location: prj.multipleLocations ? null : parseInt(prj.location[0].id, 10),
          dateFrom: prj.date_start,
          dateTo: prj.date_end_phy || __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'),
          project: prj.id_project
        });
        _this.$router.push({ path: '/data' });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.filtersOpen = false;
  }
});

/***/ }),

/***/ "SD3Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SVxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mainmenu',
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['settings']),
  data: function data() {
    return {
      isMinimized: false,
      isActive: false
    };
  },

  watch: {
    '$route.path': function $routePath(path) {
      if (this.$route.name === 'Instruments Type') {
        this.isActive = true;
      }
    }
  },
  methods: {
    minimizedNav: function minimizedNav() {
      if (window.scrollY > 0 && window.innerWidth > 1024) {
        this.isMinimized = true;
      } else {
        this.isMinimized = false;
      }
    },
    toggleMenu: function toggleMenu() {
      document.body.classList.toggle('open-menu');
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.minimizedNav);
  }
});

/***/ }),

/***/ "UOlw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_twitter_fetcher__ = __webpack_require__("Kgsj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_twitter_fetcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_twitter_fetcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_leaflet__ = __webpack_require__("MdIv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_scrollbar__ = __webpack_require__("wUfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_carousel__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var MARKERICON = function MARKERICON() {
  return __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.divIcon({
    iconSize: [4, 4],
    iconAnchor: [0, 0],
    shadowSize: [0, 0],
    className: 'marker-home'
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  metaInfo: {
    title: 'Home'
  },
  components: {
    'main-menu': __WEBPACK_IMPORTED_MODULE_3__components_MainMenu_vue__["a" /* default */],
    'v-map': __WEBPACK_IMPORTED_MODULE_6_vue2_leaflet___default.a.Map,
    'v-tilelayer': __WEBPACK_IMPORTED_MODULE_6_vue2_leaflet___default.a.TileLayer,
    'v-geojson-layer': __WEBPACK_IMPORTED_MODULE_6_vue2_leaflet___default.a.GeoJSON,
    Carousel: __WEBPACK_IMPORTED_MODULE_8_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_8_vue_carousel__["Slide"],
    VueScrollbar: __WEBPACK_IMPORTED_MODULE_7_vue2_scrollbar___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    home_markers: 'home_markers',
    home_data: 'home_data',
    mapFilters: 'mapFilters',
    settings: 'settings'
  })),
  data: function data() {
    return {
      tweets: [],
      lastupdate: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('DD/MM/YYYY'),
      url: 'https://api.mapbox.com/styles/v1/interfase/cjchvpnzl6ik22smxy02yhhmw/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaW50ZXJmYXNlIiwiYSI6ImNqZXh4ZTJpazBuajIyd3FtMXJ5eXFrNWQifQ.1B5bViv06ehjgrlidVMqOw',
      zoom: 5,
      center: [42.17, 13.12],
      options: {
        dragging: false,
        scrollWheelZoom: false,
        zoomControl: false,
        doubleClickZoom: false
      },
      markers_options: {
        pointToLayer: function pointToLayer(feature, latlng) {
          return __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.marker(latlng, { icon: MARKERICON() });
        }
      }
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('LOAD_HOME_MARKERS');
    this.$store.dispatch('LOAD_LOCATIONS_LIST');
    this.$store.dispatch('LOAD_PROJECT_LIST');

    this.fetch();
  },
  updated: function updated() {
    this.$refs.scrollbar.calculateSize();
  },

  methods: {
    yearDate: function yearDate(date) {
      return date ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('Y') : '';
    },
    fetch: function fetch() {
      var LatestTweets = {
        'profile': { 'screenName': 'OGS_MAOS' },
        'customCallback': this.setTweets,
        'maxTweets': 6,
        'enableLinks': true,
        'showUser': false,
        'showTime': true,
        'dateFunction': this.dateFormatter,
        // 'showRetweet': false,
        'showInteraction': false,
        'showImages': false
      };
      __WEBPACK_IMPORTED_MODULE_2_twitter_fetcher___default.a.fetch(LatestTweets);
    },
    setTweets: function setTweets(tweets) {
      this.tweets = tweets;
    },
    dateFormatter: function dateFormatter(date) {
      var customDate = date.toLocaleDateString();
      customDate = customDate.replace(/\//g, '/');
      customDate = customDate.split(/(?=.{6}$)/).join('<span class="month">');
      customDate = customDate.split(/(?=.{4}$)/).join('</span>');
      return customDate;
    },
    locationsChoice: function locationsChoice(id) {
      var boe = parseInt(this.home_data.boe_per_oceano_last_month[id].sum, 10);
      if (boe > 0) {
        this.$store.commit('SET_MAP_FILTERS', {
          location: id,
          dateFrom: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(30, 'days').format('YYYY-MM-DD'),
          dateTo: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'),
          nationality: 'ITALY'
        });
        this.$router.push({ path: 'data' });
      }
    },
    viewMap: function viewMap(prj) {
      this.$store.dispatch('LOAD_PROJECT', prj.id_project);
      this.$store.commit('SET_MAP_FILTERS', {
        location: prj.multipleLocations ? null : parseInt(prj.location, 10),
        dateFrom: prj.date_start,
        dateTo: prj.date_end_phy || __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'),
        project: prj.id_project
      });
      this.$router.push({ path: '/data' });
    }
  },
  filters: {
    distilled: function distilled(value) {
      // strip html and truncate string
      return value.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 150);
    }
  }
});

/***/ }),

/***/ "V0pX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VcOH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',[(_vm.data.properties.wmo)?_c('tr',[_c('td',[_vm._v("WMO")]),_c('td',[_vm._v(_vm._s(_vm.data.properties.wmo))])]):_vm._e(),(_vm.data.properties.imei)?_c('tr',[_c('td',[_vm._v("IMEI")]),_c('td',[_vm._v(_vm._s(_vm.data.properties.imei))])]):_vm._e(),(_vm.data.properties.id)?_c('tr',[_c('td',[_vm._v("ID")]),_c('td',[_vm._v(_vm._s(_vm.data.properties.id)+"  ")])]):_vm._e(),_c('tr',[_c('td',[_vm._v("MODEL")]),_c('td',[_vm._v(_vm._s(_vm.data.properties.model))])]),(_vm.data.properties.nationality)?_c('tr',[_c('td',[_vm._v("NATIONALITY")]),_c('td',[_vm._v(_vm._s(_vm.data.properties.nationality))])]):_vm._e(),(_vm.data.properties.type)?_c('tr',[_c('td',[_vm._v("DAY")]),_c('td',[_vm._v(_vm._s(_vm._f("day")(_vm.data.properties.time)))])]):_vm._e(),(_vm.data.geometry.type === 'Point')?_c('tr',[_c('td',[_vm._v("TIME")]),_c('td',[_vm._v(_vm._s(_vm._f("time")(_vm.data.properties.time)))])]):_vm._e(),(_vm.data.geometry.type === 'Point')?_c('tr',[_c('td',[_vm._v("LATITUDE")]),_c('td',[_vm._v(_vm._s(_vm.data.geometry.coordinates[1].toFixed(2)))])]):_vm._e(),(_vm.data.geometry.type === 'Point')?_c('tr',[_c('td',[_vm._v("LONGITUDE")]),_c('td',[_vm._v(_vm._s(_vm.data.geometry.coordinates[0].toFixed(2)))])]):_vm._e()]),(_vm.data.geometry.type !== 'LineString')?_c('div',{staticClass:"actions is-hidden-tablet"},[_c('button',{staticClass:"action-track",attrs:{"type":"button"},on:{"click":function($event){_vm.toggleTrack()}}},[_vm._v(_vm._s(_vm.trackLabel))])]):_vm._e(),(_vm.data.geometry.type === 'LineString')?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"action-remove",attrs:{"type":"button"},on:{"click":function($event){_vm.removeTrj(_vm.data.properties.id)}}},[_vm._v("Hide Track")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VyZF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Y7fe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home__ = __webpack_require__("j7e0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_About__ = __webpack_require__("vu9I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Data__ = __webpack_require__("ax2W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Projects__ = __webpack_require__("tjnX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Publications__ = __webpack_require__("Kyoa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Project__ = __webpack_require__("vgCo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Instruments__ = __webpack_require__("ejcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Contacts__ = __webpack_require__("GeAo");












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Home__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_4__views_About__["a" /* default */]
  }, {
    path: '/data',
    name: 'Data',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Data__["a" /* default */]
  }, {
    path: '/data/:id',
    name: 'DataProjects',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Data__["a" /* default */]
  }, {
    path: '/projects',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Projects__["a" /* default */]
  }, {
    path: '/projects/:id',
    name: 'Project',
    component: __WEBPACK_IMPORTED_MODULE_8__views_Project__["a" /* default */]
  }, {
    path: '/instruments',
    name: 'Instruments',
    component: __WEBPACK_IMPORTED_MODULE_9__views_Instruments__["a" /* default */]
  }, {
    path: '/instruments/:type',
    name: 'Instruments Type',
    component: __WEBPACK_IMPORTED_MODULE_9__views_Instruments__["a" /* default */]
  }, {
    path: '/contacts',
    name: 'Contacts',
    component: __WEBPACK_IMPORTED_MODULE_10__views_Contacts__["a" /* default */]
  }, {
    path: '/publications',
    name: 'Publications',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Publications__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    // return desired position
    return { x: 0, y: 0 };
  }
});

router.afterEach(function (to, from) {
  // Close Mobile menu
  if (document.body.className === 'open-menu') {
    document.body.classList.toggle('open-menu');
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ax2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Data_vue__ = __webpack_require__("siR2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61bc845c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Data_vue__ = __webpack_require__("73EO");
function injectStyle (ssrContext) {
  __webpack_require__("R/qB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61bc845c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61bc845c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dxIX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ejcb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instruments_vue__ = __webpack_require__("xd4y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71b1bd32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Instruments_vue__ = __webpack_require__("rOwY");
function injectStyle (ssrContext) {
  __webpack_require__("Kw7C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71b1bd32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instruments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71b1bd32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Instruments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fY8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PopupContent',
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {
          marker: ''
        };
      }
    }
  },
  data: function data() {
    return {
      trackLabel: 'View Track',
      trackStatus: true
    };
  },

  methods: {
    removeTrj: function removeTrj(id) {
      this.data.properties.delete = true;
      this.$store.commit('UNSET_TRAJECTORY', id);
    },
    toggleTrack: function toggleTrack() {
      var type = this.data.properties.type;
      var id = this.data.properties.id;
      var from = this.$store.state.mapFilters.date_from;
      var to = this.$store.state.mapFilters.date_to;
      if (this.trackStatus) {
        this.$store.dispatch('LOAD_TRAJECTORY', 'type=' + type + '&id=' + id + '&date_from=' + from + '&date_to=' + to);
        this.trackStatus = !this.trackStatus;
        this.trackLabel = 'Hide Track';
      } else {
        this.removeTrj(id);
        this.trackStatus = !this.trackStatus;
        this.trackLabel = 'View Track';
      }
    }
  },
  filters: {
    day: function day(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY');
    },
    time: function time(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('H:mm');
    }
  }
});

/***/ }),

/***/ "j7e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("UOlw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8372e7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("s2Zv");
function injectStyle (ssrContext) {
  __webpack_require__("V0pX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8372e7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8372e7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jvIr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project)?_c('main',{staticClass:"project"},[_c('header',{staticClass:"header",style:(("background-image:url(" + (_vm.project.header_url) + ")"))},[_c('main-menu'),_c('section',{staticClass:"intro"})],1),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[(_vm.project.date_range)?_c('h2',{staticClass:"subtitle mobile"},[_vm._v("("+_vm._s(_vm.project.date_range[0])+" / "+_vm._s(_vm.project.date_range[_vm.project.date_range.length - 1])+")")]):_vm._e(),_c('h1',{staticClass:"title mobile"},[_vm._v(_vm._s(_vm.project.name))]),(_vm.project.location)?_c('div',{staticClass:"legenda"},[_vm._l((_vm.project.location),function(location){return _c('ul',{key:location.id,staticClass:"link",on:{"click":function($event){_vm.viewMap(_vm.project, location.id)}}},[_c('li',{staticClass:"label"},[_vm._v(_vm._s(location.name))]),_c('li',[_vm._v("View on map")]),_c('span',{staticClass:"read-more"})])}),(_vm.project.type)?_c('ul',{staticClass:"type"},[_c('li',{staticClass:"label"},[_vm._v("Type")]),_c('ul',_vm._l((_vm.project.type),function(status){return _c('li',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(status))])])}))]):_vm._e()],2):_vm._e(),_c('div',{staticClass:"wrapper description"},[_c('div',{staticClass:"container"},[(_vm.project.logo_url)?_c('img',{staticClass:"prj--logo",attrs:{"src":_vm.project.logo_url,"alt":"logo"}}):_vm._e(),( _vm.project.date_range)?_c('h2',[_vm._v("("+_vm._s(_vm.project.date_range[0])+" / "+_vm._s(_vm.project.date_range[_vm.project.date_range.length - 1])+")")]):_vm._e(),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.project.name))]),(_vm.project.intro)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.project.intro)}}):_vm._e()])])]),(_vm.project.charts)?_c('div',{staticClass:"wrapper charts"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"is-hidden-mobile"},_vm._l((_vm.project.charts),function(chart,index){return _c('li',{key:chart.id_project_immagini,class:{ 'active': chart.is_active },on:{"click":function($event){_vm.selectTab(chart)}}},[_c('a',[_c('span',[_vm._v(_vm._s(chart.didascalia))])])])})),_c('section',{staticClass:"is-hidden-mobile"},_vm._l((_vm.project.charts),function(chart){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(chart.is_active),expression:"chart.is_active"}],key:chart.id_project_immagini},[_c('img',{staticClass:"img--chart",attrs:{"src":chart.nome_img,"alt":"chart"},on:{"click":function($event){_vm.openOverlay(chart)}}})])})),_c('ul',{staticClass:"is-hidden-tablet chartMobile"},_vm._l((_vm.project.charts),function(chart,index){return _c('li',{key:chart.id_project_immagini,class:{ 'active': chart.is_active },on:{"click":function($event){_vm.selectChart(chart)}}},[_c('div',{staticClass:"titolo"},[_vm._v(_vm._s(chart.didascalia))]),_c('div',{staticClass:"immagine"},[_c('img',{staticClass:"img--chart",attrs:{"src":chart.nome_img,"alt":"chart"}})])])}))])]):_vm._e(),_c('div',{staticClass:"wrapper deployments"},[_c('div',{staticClass:"container"},[(_vm.project.deployments && _vm.project.deployments.length)?_c('div',{staticClass:"deployment"},[_c('h3',[_vm._v("Deployments")]),_c('ul',_vm._l((_vm.project.deployments),function(item){return _c('li',{key:item.deploy.id,staticClass:"columns is-mobile"},[_c('div',{staticClass:"deployment--title column"},[_vm._v(_vm._s(item.deploy.date)),_c('span',[_vm._v(_vm._s(item.deploy.location))])]),_c('div',{staticClass:"drifter column icon"},[_c('span',{staticClass:"boa"},[_vm._v(_vm._s(item.drifters.count.active))]),_c('span',{staticClass:"separator"},[_vm._v("/")]),_c('span',[_vm._v(_vm._s(item.drifters.count.total))])]),_c('div',{staticClass:"float column icon"},[_c('span',{staticClass:"boa"},[_vm._v(_vm._s(item.floats.count.active))]),_c('span',{staticClass:"separator"},[_vm._v("/")]),_c('span',[_vm._v(_vm._s(item.floats.count.total))])]),_c('div',{staticClass:"glider column icon"},[_c('span',{staticClass:"boa"},[_vm._v(_vm._s(item.gliders.count.active))]),_c('span',{staticClass:"separator"},[_vm._v("/")]),_c('span',[_vm._v(_vm._s(item.gliders.count.total))])]),_c('div',{staticClass:"viewmap column"},[_c('a',{on:{"click":function($event){_vm.viewMapDeploy(item.deploy.id)}}},[_vm._v("View on Map")])])])}))]):_vm._e()])]),(_vm.project.scientifics.length)?_c('div',{staticClass:"wrapper documents"},[_c('div',{staticClass:"container"},_vm._l((_vm.project.scientifics),function(doc,index){return _c('div',{key:doc.id_project_desc,staticClass:"columns"},[_c('div',{staticClass:"column"}),_c('div',{staticClass:"column"},[_c('p',{domProps:{"innerHTML":_vm._s(doc.descrizione)}})])])}))]):_vm._e(),(_vm.project.images_data)?_c('div',{staticClass:"wrapper mediagallery"},[_c('div',{staticClass:"gallery container"},[_vm._m(0),_c('carousel',{attrs:{"perPage":1,"perPageCustom":[[768, 2], [1024, 3]],"loop":true,"paginationColor":"#c2c2c2","paginationActiveColor":"#5477a3"}},[_vm._l((_vm.project.images_data),function(image,index){return _c('slide',{key:index,style:(("background-image:url(" + (image.nome_img) + ")")),on:{"slideClick":function($event){_vm.openOverlay(image)}}},[_c('p',[_vm._v(_vm._s(image.didascalia))])])}),(_vm.project.images_data.length < 3)?_c('slide',{staticClass:"noimg"}):_vm._e(),(_vm.project.images_data.length === 1)?_c('slide',{staticClass:"noimg"}):_vm._e()],2)],1)]):_vm._e(),(_vm.project.reports)?_c('div',{staticClass:"wrapper reports"},[_c('div',{staticClass:"reports container"},[_c('h3',[_vm._v("download report")]),_c('ul',{staticClass:"pdf",attrs:{"project.reports":"project.reports"}},_vm._l((_vm.project.reports),function(report){return _c('li',[_c('a',{attrs:{"href":report.url,"target":"new"}},[_vm._v(_vm._s(report.titolo))])])}))])]):_vm._e(),(_vm.project.people)?_c('div',{staticClass:"wrapper people"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("people involved")]),_c('div',{staticClass:"columns people"},_vm._l((_vm.project.people),function(item){return _c('div',{staticClass:"internal column",class:("team-" + (item.maos))},[_c('div',{staticClass:"picture"},[_c('img',{attrs:{"src":("" + (item.foto.replace(' ', '%20'))),"width":"264","height":"150","alt":"foto"}})]),_c('h2',[_vm._v(_vm._s(item.nome)+" "+_vm._s(item.cognome))]),_c('h3',[_vm._v(_vm._s(item.tipo))]),(item.email_to)?_c('h4',{staticClass:"mail"},[_vm._v(_vm._s(item.email_to))]):_vm._e(),(item.tel)?_c('h4',{staticClass:"phone"},[_vm._v(_vm._s(item.tel))]):_vm._e(),(item.maos === 't')?_c('p',{staticClass:"more-info"},[_c('a',{attrs:{"href":item.www,"target":"new"}},[_vm._v("more info")])]):_vm._e()])}))])]):_vm._e(),(_vm.collaborators.length)?_c('div',{staticClass:"wrapper-partners"},[_c('div',{staticClass:"container columns"},[_c('h1',{staticClass:"label column"},[_vm._v("collaborators")]),_c('div',{staticClass:"column columns partners"},_vm._l((_vm.collaborators),function(partner){return _c('div',{key:partner.id_sponsor,staticClass:"wrapper-logo"},[_c('a',{staticClass:"logo column",attrs:{"href":partner.link,"target":"_blank"}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":partner.logo,"width":"72","height":"96"}})]),_c('div',{staticClass:"partner-name"},[_c('p',[_vm._v(_vm._s(partner.nome))])])])])}))])]):_vm._e(),(_vm.externalProjects.length)?_c('div',{staticClass:"wrapper-partners"},[_c('div',{staticClass:"container columns"},[_c('h1',{staticClass:"label column"},[_vm._v("External related links")]),_c('div',{staticClass:"column columns partners"},_vm._l((_vm.externalProjects),function(partner){return _c('div',{key:partner.id_sponsor,staticClass:"wrapper-logo"},[_c('a',{staticClass:"logo column",attrs:{"href":partner.link,"target":"_blank"}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":partner.logo,"width":"72","height":"96"}})]),_c('div',{staticClass:"partner-name"},[_c('p',[_vm._v(_vm._s(partner.nome))])])])])}))])]):_vm._e(),(_vm.mainSponsor.length)?_c('div',{staticClass:"wrapper-partners"},[_c('div',{staticClass:"container columns"},[_c('h1',{staticClass:"label column"},[_vm._v("main sponsors")]),_c('div',{staticClass:"column columns partners"},_vm._l((_vm.mainSponsor),function(partner){return _c('div',{key:partner.id_sponsor,staticClass:"wrapper-logo"},[_c('a',{staticClass:"logo column",attrs:{"href":partner.link,"target":"_blank"}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":partner.logo,"width":"72","height":"96"}})]),_c('div',{staticClass:"partner-name"},[_c('p',[_vm._v(_vm._s(partner.nome))])])])])}))])]):_vm._e(),_c('div',{staticClass:"overlay",class:{ open: _vm.overlay.open },on:{"click":_vm.closeOverlay}},[_c('div',{staticClass:"slide"},[_c('img',{attrs:{"src":_vm.overlay.image,"alt":"image instrument"}})]),_c('span',{staticClass:"close",on:{"click":_vm.closeOverlay}},[_vm._v("×")])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v("media"),_c('span',[_vm._v(" gallery")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kPAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopupContent_vue__ = __webpack_require__("fY8w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca74168_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PopupContent_vue__ = __webpack_require__("VcOH");
function injectStyle (ssrContext) {
  __webpack_require__("s03j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ca74168"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopupContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca74168_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PopupContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lQeg":
/***/ (function(module, exports) {

module.exports = {"_args":[["proj4@2.4.4","/Users/nicola/Progetti/maos-inogs"]],"_from":"proj4@2.4.4","_id":"proj4@2.4.4","_inBundle":false,"_integrity":"sha512-yo6qTpBQXnxhcPopKJeVwwOBRzUpEa3vzSFlr38f5mF4Jnfb6NOL/ePIomefWiZmPgkUblHpcwnWVMB8FS3GKw==","_location":"/proj4","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"proj4@2.4.4","name":"proj4","escapedName":"proj4","rawSpec":"2.4.4","saveSpec":null,"fetchSpec":"2.4.4"},"_requiredBy":["/proj4leaflet"],"_resolved":"https://registry.npmjs.org/proj4/-/proj4-2.4.4.tgz","_spec":"2.4.4","_where":"/Users/nicola/Progetti/maos-inogs","author":"","bugs":{"url":"https://github.com/proj4js/proj4js/issues"},"contributors":[{"name":"Mike Adair","email":"madair@dmsolutions.ca"},{"name":"Richard Greenwood","email":"rich@greenwoodmap.com"},{"name":"Calvin Metcalf","email":"calvin.metcalf@gmail.com"},{"name":"Richard Marsden","url":"http://www.winwaed.com"},{"name":"T. Mittan"},{"name":"D. Steinwand"},{"name":"S. Nelson"}],"dependencies":{"mgrs":"1.0.0","wkt-parser":"^1.2.0"},"description":"Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.","devDependencies":{"chai":"~1.8.1","curl":"git://github.com/cujojs/curl.git","grunt":"^1.0.1","grunt-cli":"~0.1.13","grunt-contrib-connect":"~0.6.0","grunt-contrib-jshint":"~1.1.0","grunt-contrib-uglify":"~0.11.1","grunt-mocha-phantomjs":"~0.4.0","grunt-rollup":"^1.0.1","istanbul":"~0.2.4","mocha":"~1.17.1","rollup":"^0.41.4","rollup-plugin-json":"^2.0.1","rollup-plugin-node-resolve":"^2.0.0","tin":"~0.4.0"},"directories":{"test":"test","doc":"docs"},"homepage":"https://github.com/proj4js/proj4js#readme","license":"MIT","main":"dist/proj4-src.js","module":"lib/index.js","name":"proj4","repository":{"type":"git","url":"git://github.com/proj4js/proj4js.git"},"scripts":{"build":"grunt","build:tmerc":"grunt build:tmerc","test":"npm run build && istanbul test _mocha test/test.js"},"version":"2.4.4"}

/***/ }),

/***/ "p4h2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project',
  metaInfo: {
    title: 'Project'
  },
  components: {
    'main-menu': __WEBPACK_IMPORTED_MODULE_1__components_MainMenu_vue__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Slide"]
  },
  computed: {
    project: function project() {
      return this.$store.getters.project;
    },
    mainSponsor: function mainSponsor() {
      return this.$store.getters.project.sponsor ? this.$store.getters.project.sponsor.filter(function (s) {
        return s.type === 'main_sponsor';
      }) : false;
    },
    collaborators: function collaborators() {
      return this.$store.getters.project.sponsor ? this.$store.getters.project.sponsor.filter(function (s) {
        return s.type === 'main_collaborator';
      }) : false;
    },
    externalProjects: function externalProjects() {
      return this.$store.getters.project.sponsor ? this.$store.getters.project.sponsor.filter(function (s) {
        return s.type === 'external';
      }) : false;
    }
  },
  data: function data() {
    return {
      msg: 'PROJECTS',
      overlay: {
        open: false,
        image: ''
      }
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('LOAD_PROJECT', this.$route.params.id);
    this.$store.dispatch('LOAD_LOCATIONS_LIST');
  },

  methods: {
    viewMap: function viewMap(project, location) {
      this.$store.commit('SET_MAP_FILTERS', {
        location: location,
        dateFrom: project.date_start,
        dateTo: project.date_end_phy || __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
        project: project.id_project
      });
      this.$router.push({ path: '/data' });
    },
    viewMapDeploy: function viewMapDeploy(id) {
      console.log('id', id);
      this.$store.commit('SET_MAP_FILTERS', {
        location: null,
        dateFrom: this.project.date_start,
        dateTo: this.project.date_end_phy || __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
        project: this.project.id_project,
        deployment: id
      });
      this.$router.push({ path: '/data' });
    },
    selectTab: function selectTab(selectedTab) {
      this.project.charts.forEach(function (tab) {
        tab.is_active = tab.id_project_immagini === selectedTab.id_project_immagini;
      });
    },
    selectChart: function selectChart(selectedTab) {
      this.project.charts.forEach(function (tab) {
        tab.is_active = tab.id_project_immagini === selectedTab.id_project_immagini;
      });
    },
    openOverlay: function openOverlay(slide) {
      this.overlay.open = true;
      this.overlay.image = slide.nome_img;
    },
    closeOverlay: function closeOverlay() {
      this.overlay.open = false;
    }
  }
});

/***/ }),

/***/ "pENx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/float-tile-instrument.628e950.jpg";

/***/ }),

/***/ "qycJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_leaflet__ = __webpack_require__("MdIv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var MARKERICON = function MARKERICON() {
  return __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.divIcon({
    iconSize: [20, 20],
    iconAnchor: [0, 0],
    shadowSize: [0, 0],
    className: 'marker-contact'
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contacts',
  metaInfo: {
    title: 'Contacts'
  },
  components: {
    'main-menu': __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__["a" /* default */],
    'v-map': __WEBPACK_IMPORTED_MODULE_3_vue2_leaflet___default.a.Map,
    'v-tilelayer': __WEBPACK_IMPORTED_MODULE_3_vue2_leaflet___default.a.TileLayer,
    'v-geojson-layer': __WEBPACK_IMPORTED_MODULE_3_vue2_leaflet___default.a.GeoJSON,
    Carousel: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Slide"]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['settings']),
  data: function data() {
    return {
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      zoom: 12,
      center: [45.7674236, 13.741648],
      options: {
        dragging: true,
        scrollWheelZoom: false,
        zoomControl: false
      },
      geojson: {
        'type': 'FeatureCollection',
        'features': [{
          'type': 'Feature',
          'properties': {
            'title': 'OGS'
          },
          'geometry': {
            'type': 'Point',
            'coordinates': [13.7626238, 45.7106708]
          }
        }]
      },
      markers_options: {
        pointToLayer: function pointToLayer(feature, latlng) {
          return __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.marker(latlng, { icon: MARKERICON() });
        }
      }
    };
  }
});

/***/ }),

/***/ "rOwY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('main',{staticClass:"instruments"},[_c('header',{staticClass:"header"},[_c('main-menu'),_c('carousel',{attrs:{"perPage":1,"autoplay":true,"autoplayHoverPause":true,"loop":true,"autoplayTimeout":6000,"paginationColor":"#f8f8f8","paginationActiveColor":"#5477a3"}},_vm._l((_vm.settings.sections.instruments.carousel),function(slide,index){return _c('slide',{key:index,style:(("background-image:url(" + slide + ")"))})}))],1),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[(_vm.instrument)?_c('div',{staticClass:"description",class:_vm.title},[_c('h1',[_vm._v("OUR INSTRUMENTS")]),_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.instrument.description)}})]):_vm._e(),(_vm.instrument.models)?_c('div',{staticClass:"instrument"},_vm._l((_vm.instrument.models),function(generic,index){return _c('div',{key:("generic" + index),staticClass:"wrapp-generic"},[_c('div',{staticClass:"generic",class:{ open: generic.open }},[_c('div',{staticClass:"button",on:{"click":function($event){_vm.openDetails(generic)}}},[_vm._m(0,true)]),_c('div',{staticClass:"name"},[_c('h1',[_vm._v(_vm._s(generic.name))]),_c('div',{staticClass:"metadata"},[_c('h3',[_vm._v(_vm._s(generic.count_active)),_c('span',[_vm._v("/ Active Now")])])])]),_c('div',{staticClass:"more"},[_c('p',{domProps:{"innerHTML":_vm._s(generic.description || '')}}),(generic.images.length)?_c('div',{staticClass:"gallery"},[_c('h4',[_vm._v(_vm._s(generic.name)),_c('span',[_vm._v(" gallery")])]),_c('carousel',{attrs:{"perPage":1,"perPageCustom":[[768, 2], [1024, 3]],"loop":true,"paginationColor":"#f8f8f8","paginationActiveColor":"#5477a3"}},[_vm._l((generic.images),function(image){return _c('slide',{key:image.id,class:{video: image.id_type === 2},on:{"slideClick":function($event){_vm.openOverlay(image)}}},[(image.id_type === 1)?_c('div',{style:(("background-image:url(" + (image.url) + ")"))}):_vm._e(),(image.id_type === 2)?_c('vimeo-player',{attrs:{"video-id":image.url,"player-width":"380"},on:{"ready":_vm.onReadyVideo}}):_vm._e(),(image.id_type === 1)?_c('p',[_vm._v(_vm._s(image.didascalia))]):_vm._e()],1)}),(generic.images.length < 3)?_c('slide',{staticClass:"noimg"}):_vm._e(),(generic.images.length === 1)?_c('slide',{staticClass:"noimg"}):_vm._e()],2)],1):_vm._e(),(generic.instruments.length)?_c('div',{staticClass:"model-wrapper"},_vm._l((generic.instruments),function(model){return _c('div',{key:model.id_type,staticClass:"model"},[(model.count_active)?_c('div',{staticClass:"metadata"},[_c('h3',[_vm._v(_vm._s(model.count_active)),_c('span',[_vm._v("/ Active Now")])]),_c('a',{on:{"click":function($event){_vm.viewMap(model.id_type)}}},[_vm._v("Vedi la mappa")])]):_vm._e(),_c('h2',[_vm._v(_vm._s(model.name))]),(model.desc_long)?_c('p',{staticClass:"model--description",domProps:{"innerHTML":_vm._s(model.desc_long)}}):_c('p'),(model.docs)?_c('ul',{staticClass:"reports"},_vm._l((model.docs),function(doc){return _c('li',{key:doc.id},[_c('a',{attrs:{"href":generic.url,"target":"new"}},[_vm._v(_vm._s(generic.didascalia))])])})):_vm._e()])})):_vm._e()])])])})):_vm._e(),_c('div',{staticClass:"navigation"},[(this.$route.params.type === 'drifters')?_c('router-link',{attrs:{"to":"/instruments/floats"}},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("pENx"),"width":"251","height":"202"}})]),_c('div',[_c('h1',[_vm._v("instruments")]),_c('h2',[_vm._v("Floats")]),_c('span',{staticClass:"arrow"})])]):_c('router-link',{attrs:{"to":"/instruments/drifters"}},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("03+3"),"width":"251","height":"202"}})]),_c('div',[_c('h1',[_vm._v("instruments")]),_c('h2',[_vm._v("Drifters")]),_c('span',{staticClass:"arrow"})])]),(this.$route.params.type === 'gliders')?_c('router-link',{attrs:{"to":"/instruments/floats"}},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("pENx"),"width":"251","height":"202"}})]),_c('div',[_c('h1',[_vm._v("instruments")]),_c('h2',[_vm._v("Floats")]),_c('span',{staticClass:"arrow"})])]):_c('router-link',{attrs:{"to":"/instruments/gliders"}},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("NPRs"),"width":"251","height":"202"}})]),_c('div',[_c('h1',[_vm._v("instruments")]),_c('h2',[_vm._v("Gliders")]),_c('span',{staticClass:"arrow"})])])],1),_c('div',{staticClass:"overlay",class:{ open: _vm.overlay.open },on:{"click":_vm.closeOverlay}},[_c('div',{staticClass:"slide"},[_c('img',{attrs:{"src":_vm.overlay.image,"alt":"image instrument"}})]),_c('span',{staticClass:"close",on:{"click":_vm.closeOverlay}},[_vm._v("×")])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span'),_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s03j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s2Zv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('main',{staticClass:"home"},[_c('header',{staticClass:"header"},[_c('main-menu'),_c('carousel',{attrs:{"perPage":1,"autoplay":true,"autoplayHoverPause":true,"loop":true,"autoplayTimeout":6000,"paginationColor":"#f8f8f8","paginationActiveColor":"#5477a3"}},_vm._l((_vm.settings.sections.home.carousel),function(slide,index){return _c('slide',{key:index,style:(("background-image:url(" + slide + ")"))})}))],1),(_vm.home_data)?_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',[_c('div',{staticClass:"quote"},[_c('h1',[_vm._v(_vm._s(_vm.settings.sections.home.quote.text))]),_c('p',[_vm._v(" "+_vm._s(_vm.settings.sections.home.quote.author))])]),_c('div',{staticClass:"tweets"},[_vm._m(0),_c('vue-scrollbar',{ref:"scrollbar",staticClass:"tweets--wrapp"},[_c('div',_vm._l((_vm.tweets),function(tweet){return _c('div',{staticClass:"tweet--item",domProps:{"innerHTML":_vm._s(tweet)}})}))]),_vm._m(1)],1)]),_c('div',{staticClass:"intro"},[_c('h3',[_vm._v("MAOS GROUP")]),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.settings.sections.about.subtitle))]),_c('p',[_vm._v(_vm._s(_vm.settings.sections.about.description)),_c('span',[_c('router-link',{staticClass:"read-more",attrs:{"to":"about"}},[_vm._v("Read more")])],1)])])]),_c('div',{staticClass:"map"},[_c('div',{staticClass:"map__wrapp"},[_c('v-map',{ref:"map",attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":_vm.options}},[_c('v-tilelayer',{attrs:{"url":_vm.url}}),(_vm.home_markers)?_c('v-geojson-layer',{ref:"markers",attrs:{"geojson":_vm.home_markers,"options":_vm.markers_options}}):_vm._e()],1)],1),_c('div',{staticClass:"live-data container"},[_c('h1',[_vm._v("active instruments")]),_c('p',{staticClass:"live"},[_vm._v("last update"),_c('span',[_vm._v(" "+_vm._s(_vm.lastupdate))])]),(_vm.home_data.totale_boe)?_c('table',[_c('tr',[_c('td',[_c('div',{staticClass:"boe-icon drifter"},[_c('span',[_vm._v(_vm._s(_vm.home_data.totale_boe.drifter))]),_c('span',[_vm._v("Drifters")])])])]),_c('tr',[_c('td',[_c('div',{staticClass:"boe-icon float"},[_c('span',[_vm._v(_vm._s(_vm.home_data.totale_boe.float))]),_c('span',[_vm._v("Floats")])])])]),_c('tr',[_c('td',[_c('div',{staticClass:"boe-icon glider"},[_c('span',[_vm._v(_vm._s(_vm.home_data.totale_boe.glider))]),_c('span',[_vm._v("Gliders")])])])])]):_vm._e()]),(_vm.home_data.boe_per_oceano_last_month)?_c('div',{staticClass:"tabs"},[_c('div',{on:{"click":function($event){_vm.locationsChoice('5')}}},[_c('h1',[_vm._v(_vm._s(_vm.home_data.boe_per_oceano_last_month['5'].area))]),_c('h2',[_vm._v(_vm._s(_vm.home_data.boe_per_oceano_last_month['5'].sum)),_c('span',[_vm._v(" Total Instruments")])]),(_vm.home_data.boe_per_oceano_last_month['5'].sum !== '0')?_c('a',{staticClass:"read-more"},[_c('span',[_vm._v("View on Map")])]):_vm._e()]),_c('div',{on:{"click":function($event){_vm.locationsChoice('18')}}},[_c('h1',[_vm._v(_vm._s(_vm.home_data.boe_per_oceano_last_month['18'].area))]),_c('h2',[_vm._v(_vm._s(_vm.home_data.boe_per_oceano_last_month['18'].sum)),_c('span',[_vm._v(" Total Instruments")])]),(_vm.home_data.boe_per_oceano_last_month['18'].sum !== '0')?_c('a',{staticClass:"read-more"},[_c('span',[_vm._v("View on Map")])]):_vm._e()]),_c('div',{on:{"click":function($event){_vm.locationsChoice('2')}}},[_c('h1',[_vm._v(_vm._s(_vm.home_data.boe_per_oceano_last_month['2'].area))]),_c('h2',[_vm._v(_vm._s(_vm.home_data.boe_per_oceano_last_month['2'].sum)),_c('span',[_vm._v(" Total Instruments")])]),(_vm.home_data.boe_per_oceano_last_month['2'].sum !== '0')?_c('a',{staticClass:"read-more"},[_c('span',[_vm._v("View on Map")])]):_vm._e()]),_c('div',{on:{"click":function($event){_vm.locationsChoice('19')}}},[_c('h1',[_vm._v(_vm._s(_vm.home_data.boe_per_oceano_last_month['19'].area))]),_c('h2',[_vm._v(_vm._s(_vm.home_data.boe_per_oceano_last_month['19'].sum)),_c('span',[_vm._v(" Total Instruments")])]),(_vm.home_data.boe_per_oceano_last_month['19'].sum !== '0')?_c('a',{staticClass:"read-more"},[_c('span',[_vm._v("View on Map")])]):_vm._e()])]):_vm._e()]),_c('div',{staticClass:"instruments"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("instruments")]),(_vm.home_data.instruments_drifters)?_c('div',{staticClass:"tiles"},[_c('router-link',{attrs:{"to":"/instruments/drifters"}},[_c('h1',[_vm._v("Drifters")]),_c('img',{attrs:{"src":__webpack_require__("Pm90"),"width":"360","height":"188"}}),_c('p',[_vm._v(_vm._s(_vm._f("distilled")(_vm.home_data.instruments_drifters.description))+" ...")]),_c('router-link',{attrs:{"to":"/instruments/drifters"}},[_vm._v("read more")])],1),_c('router-link',{attrs:{"to":"/instruments/floats"}},[_c('h1',[_vm._v("Floats")]),_c('img',{attrs:{"src":__webpack_require__("Fqc9"),"width":"360","height":"188"}}),_c('p',[_vm._v(_vm._s(_vm._f("distilled")(_vm.home_data.instruments_floats.description))+" ...")]),_c('router-link',{attrs:{"to":"/instruments/floats"}},[_vm._v("read more")])],1),_c('router-link',{attrs:{"to":"/instruments/gliders"}},[_c('h1',[_vm._v("Gliders")]),_c('img',{attrs:{"src":__webpack_require__("sVDA"),"width":"360","height":"188"}}),_c('p',[_vm._v(_vm._s(_vm._f("distilled")(_vm.home_data.instruments_gliders.description))+" ...")]),_c('router-link',{attrs:{"to":"/instruments/gliders"}},[_vm._v("read more")])],1)],1):_vm._e()])]),_c('div',{staticClass:"wrapper container"},[(_vm.home_data.ultimi_progetti)?_c('div',{staticClass:"projects"},[_c('div',[_c('h2',[_vm._v("latest")]),_c('h1',[_vm._v("projects")]),_c('router-link',{attrs:{"to":"projects"}})],1),_vm._l((_vm.home_data.ultimi_progetti),function(project,index){return _c('div',{key:("project-" + index),staticClass:"project"},[_c('router-link',{attrs:{"to":("projects/" + (project.id_project))}},[_c('span',[_vm._v(_vm._s(project.name)+" - "+_vm._s(_vm.yearDate(project.date_start)))]),_c('span',{staticClass:"locations"},[_c('i',{staticClass:"separator"},[_vm._v("/")]),_vm._v(_vm._s(project.location_name))])]),_c('p',[_vm._v(_vm._s(project.total || 0)),_c('span',[_vm._v(" total instruments")])]),_c('router-link',{staticClass:"project-info",attrs:{"to":("projects/" + (project.nome_www))}},[_c('span',[_vm._v("Project Info")])]),_c('a',{on:{"click":function($event){_vm.viewMap(project)}}},[_c('span',[_vm._v("View on Map")])])],1)})],2):_vm._e()])]):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tweets--title"},[_c('h2',[_vm._v("Latest")]),_c('h1',[_vm._v("tweets")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tweets--actions"},[_c('a',{attrs:{"href":"https://twitter.com/OGS_MAOS","target":"new"}},[_vm._v("View on Twitter")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sVDA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home-instrument-gliders.0ba6c0a.jpg";

/***/ }),

/***/ "siR2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multipane__ = __webpack_require__("YnPe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_scrollbar__ = __webpack_require__("wUfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_esri_leaflet__ = __webpack_require__("VguC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_esri_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_esri_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_proj4leaflet__ = __webpack_require__("+INe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_proj4leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_proj4leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_PopupContent__ = __webpack_require__("kPAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue2_leaflet__ = __webpack_require__("MdIv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__("0xDb");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import axios from 'axios'




// https://sagalbot.github.io/vue-select/docs/

// https://momentjs.com/

// GIS





// import FreeDraw from 'leaflet-freedraw'


// const freeDraw = new FreeDraw()

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataView',
  metaInfo: {
    title: 'Data'
  },
  components: {
    'main-menu': __WEBPACK_IMPORTED_MODULE_4__components_MainMenu_vue__["a" /* default */],
    'v-select': __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a,
    'v-map': __WEBPACK_IMPORTED_MODULE_13_vue2_leaflet___default.a.Map,
    'v-geojson-layer': __WEBPACK_IMPORTED_MODULE_13_vue2_leaflet___default.a.GeoJSON,
    'multipane': __WEBPACK_IMPORTED_MODULE_5_vue_multipane__["a" /* Multipane */],
    'multipane-resizer': __WEBPACK_IMPORTED_MODULE_5_vue_multipane__["b" /* MultipaneResizer */],
    VueScrollbar: __WEBPACK_IMPORTED_MODULE_6_vue2_scrollbar___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    settings: 'settings',
    locationsBox: 'locationsBox',
    home_data: 'home_data',
    boeSearch: 'boeSearch',
    mapFilters: 'mapFilters',
    rengeMarkers: 'rengeMarkers',
    trajectories: 'trajectories',
    loadedBoe: 'loadedBoe',
    loadedTable: 'loadedTable'
  }), {
    markers: function markers() {
      return this.$store.getters.markers;
    },
    instrumentsFilter: function instrumentsFilter() {
      return this.$store.getters.instrumentsFilter;
    },
    locations: function locations() {
      return this.$store.getters.selectLocations;
    },
    projects: function projects() {
      return this.$store.getters.selectProjects;
    },
    project: function project() {
      return this.$store.getters.project;
    },
    nationality: function nationality() {
      return this.$store.getters.nationality;
    },
    wmo: function wmo() {
      return this.$store.getters.wmo;
    },
    imei: function imei() {
      return this.$store.getters.imei;
    },
    idBoe: function idBoe() {
      return this.$store.getters.idBoe;
    },
    boeCount: function boeCount() {
      return this.$store.getters.boeCount;
    },
    boeSearchCount: function boeSearchCount() {
      return this.$store.getters.boeSearchCount;
    },
    boe: function boe() {
      return this.$store.getters.boe;
    },
    antarcticArea: function antarcticArea() {
      if (this.prjLocator.active && this.prjLocator.location) {
        var area = this.prjLocator.location.filter(function (l) {
          return l.id === 19;
        })[0] ? this.prjLocator.location.filter(function (l) {
          return l.id === 19;
        })[0].name : this.home_data.boe_per_oceano_last_month['19'].area;
        var sum = this.prjLocator.location.filter(function (l) {
          return l.id === 19;
        })[0] ? this.prjLocator.location.filter(function (l) {
          return l.id === 19;
        })[0].total : 0;
        var item = {
          sum: sum,
          area: area
        };
        return item;
      } else {
        return this.home_data.boe_per_oceano_last_month['19'];
      }
    },
    mediterraneanSea: function mediterraneanSea() {
      if (this.prjLocator.active && this.prjLocator.location) {
        var area = this.prjLocator.location.filter(function (l) {
          return l.id === 5;
        })[0] ? this.prjLocator.location.filter(function (l) {
          return l.id === 5;
        })[0].name : this.home_data.boe_per_oceano_last_month['5'].area;
        var sum = this.prjLocator.location.filter(function (l) {
          return l.id === 5;
        })[0] ? this.prjLocator.location.filter(function (l) {
          return l.id === 5;
        })[0].total : 0;
        var item = {
          sum: sum,
          area: area
        };
        return item;
      } else {
        return this.home_data.boe_per_oceano_last_month['5'];
      }
    },
    blackSea: function blackSea() {
      if (this.prjLocator.active && this.prjLocator.location) {
        var area = this.prjLocator.location.filter(function (l) {
          return l.id === 18;
        })[0] ? this.prjLocator.location.filter(function (l) {
          return l.id === 18;
        })[0].name : this.home_data.boe_per_oceano_last_month['18'].area;
        var sum = this.prjLocator.location.filter(function (l) {
          return l.id === 18;
        })[0] ? this.prjLocator.location.filter(function (l) {
          return l.id === 18;
        })[0].total : 0;
        var item = {
          sum: sum,
          area: area
        };
        return item;
      } else {
        return this.home_data.boe_per_oceano_last_month['18'];
      }
    },
    atlanticOcean: function atlanticOcean() {
      if (this.prjLocator.active && this.prjLocator.location) {
        var area = this.prjLocator.location.filter(function (l) {
          return l.id === 2;
        })[0] ? this.prjLocator.location.filter(function (l) {
          return l.id === 2;
        })[0].name : this.home_data.boe_per_oceano_last_month['2'].area;
        var sum = this.prjLocator.location.filter(function (l) {
          return l.id === 2;
        })[0] ? this.prjLocator.location.filter(function (l) {
          return l.id === 2;
        })[0].total : 0;
        var item = {
          sum: sum,
          area: area
        };
        return item;
      } else {
        return this.home_data.boe_per_oceano_last_month['2'];
      }
    }
  }),
  data: function data() {
    var _this = this;

    return {
      trjId: [],
      deploy: [],
      hiddenId: [],
      tableCaption: 'Selection',
      tableView: false,
      statusPanel: false,
      boeSelected: [],
      typeId: '',
      typeInstrument: 'WMO',
      table: {
        theme: 'bulma',
        columns: ['select', 'hide', 'trj', 'type', 'id_boa', 'wmo', 'imei', 'kml', 'deployment_time', 'lat', 'lon', 'transmission_last_date', 'last_lat', 'last_lon', 'mission_days'],
        columnsbis: ['select', 'hide', 'trj', 'type', 'id_boa', 'wmo', 'imei', 'kml', 'country_www', 'cycle', 'oceano_name', 'generic', 'depth', 'tipo_det', 'status_tx'],
        options: {
          orderBy: {
            column: 'deployment_time'
          },
          sortable: ['type', 'id_boa', 'wmo', 'imei', 'deployment_time', 'lat', 'lon', 'transmission_last_date', 'last_lat', 'last_lon', 'mission_days', 'country_www', 'cycle', 'oceano_name', 'generic', 'depth', 'tipo_det', 'status_tx'],
          perPage: 1000,
          columnsClasses: {
            status: 'status'
          },
          pagination: { dropdown: false },
          headings: {
            select: 'go to',
            id_boa: 'id',
            tipo_det: 'transmission',
            generic: 'model',
            country_www: 'country',
            oceano_name: 'location',
            lat: 'deploy lat',
            lon: 'deploy lon',
            deployment_time: 'deploy date',
            transmission_last_date: 'last date',
            latitude: 'last_lat',
            longitude: 'last_lon',
            mission_days: 'mission days'
          },
          rowClassCallback: function rowClassCallback(row) {
            return row.selected;
          },

          customSorting: {
            // tmp mettiamo number nell'API?
            depth: function depth(ascending) {
              return function (a, b) {
                var lastA = parseInt(a.id_boa, 10);
                var lastB = parseInt(b.id_boa, 10);
                if (ascending) {
                  return lastA >= lastB ? 1 : -1;
                } else {
                  return lastA <= lastB ? 1 : -1;
                }
              };
            },
            id_boa: function id_boa(ascending) {
              return function (a, b) {
                var lastA = parseInt(a.id_boa, 10);
                var lastB = parseInt(b.id_boa, 10);
                if (ascending) {
                  return lastA >= lastB ? 1 : -1;
                } else {
                  return lastA <= lastB ? 1 : -1;
                }
              };
            }
          }
        }
      },
      period: '',
      defaultLoc: null,
      prjSelected: null,
      deploySelected: null,
      instrumentSelected: {
        label: null
      },
      nationalitySelected: null,
      fromSelect: '1996-04-01',
      toSelect: '1996-04-01',
      extent: true,
      prjLocator: {
        active: false,
        location: []
      },
      bounds: __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.latLngBounds(),
      bathyLayer: __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.tileLayer('http://services.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}', {
        attribution: 'Esri, Garmin, GEBCO, NOAA NGDC, and other contributors',
        crs: __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.CRS.EPSG3857
      }),
      antarticaLayer: Object(__WEBPACK_IMPORTED_MODULE_10_esri_leaflet__["dynamicMapLayer"])({
        url: 'https://maps.units.it/arcgis/rest/services/Antartis/antapub_bg_full/MapServer/',
        opacity: 1
      }),
      antarticCRS: new __WEBPACK_IMPORTED_MODULE_11_proj4leaflet___default.a.CRS('EPSG:3031', '+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs', {
        resolutions: [16933.367200067736, 8466.683600033868, 4233.341800016934, 2116.670900008467, 1058.3354500042335, 529.1677250021168, 264.5838625010584, 132.2919312505292],
        origin: [-2.0E7, 1.9E7]
      }),
      center: [17.245, 17.139],
      zoom: 0,
      minZoom: 0,
      maxZoom: 10,
      markersOptions: {
        pointToLayer: function pointToLayer(feature, latlng) {
          return __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.marker(latlng, { icon: Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* MARKERICON */])(feature.properties) });
        },
        onEachFeature: function onEachFeature(feature, layer) {
          var Popup = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_12__components_PopupContent__["a" /* default */]);
          var popup = new Popup({
            store: _this.$store,
            propsData: { data: feature }
          });
          // bind click
          layer.on({ click: _this.onGeoJsonClick.bind(_this) });
          layer.on({ popupclose: _this.popUpClose.bind(_this) });
          layer.bindPopup(popup.$mount().$el);
        }
      },
      trajectoriesOptions: {
        style: function style(feature) {
          return { color: feature.properties.stroke };
        },
        onEachFeature: function onEachFeature(feature, layer) {
          var Popup = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_12__components_PopupContent__["a" /* default */]);
          var popup = new Popup({
            store: _this.$store,
            propsData: { data: feature }
          });
          // bind click
          layer.on({ click: _this.onGeoJsonClick.bind(_this) });
          layer.on({ popupclose: _this.popUpClose.bind(_this) });
          layer.bindPopup(popup.$mount().$el);
        }
      }
    };
  },
  created: function created() {
    this.$store.commit('CLEAR_TRAJECTORIES');
  },
  mounted: function mounted() {
    // this.extent = true
    this.prjLocator.active = false;
    this.init();
    this.$store.dispatch('LOAD_HOME_DATA');
    this.$store.dispatch('LOAD_LOCATIONS_LIST');
    this.$store.dispatch('LOAD_FILTER_PROJECT_LIST', this.parameters(this.mapFilters));
  },

  watch: {
    'markers': function markers(g) {
      if (g && g.hasOwnProperty('features') && g.features.length && this.extent) {
        this.flyTo();
      }
    }
  },
  methods: {
    init: function init() {
      if (this.mapFilters.location || this.mapFilters.instrument || this.mapFilters.project || this.mapFilters.deployment) {
        this.renderData(this.mapFilters);
      }
    },
    renderData: function renderData(filters) {
      var _this2 = this;

      this.defaultLoc = this.locations.filter(function (l) {
        return parseInt(l.id, 10) === parseInt(filters.location, 10);
      })[0];
      if (filters.project && filters.location) {
        var projectSelect = this.$store.getters.project;
        this.$nextTick(function () {
          this.prjSelected = {
            id: projectSelect.id_project,
            value: filters.project,
            label: projectSelect.name || '',
            date_start: filters.date_from,
            date_end: filters.date_to,
            id_oceano: filters.location,
            deployments: projectSelect.deployments
          };
          this.tableCaption = projectSelect.name;
          this.$store.state.locationsBox = false;
          this.prjLocator.active = false;
          this.prjLocator.location = projectSelect.location;
          this.mygeojson();
          this.loadBoe('table');
          this.loadBoe('list');
        });
      } else if (filters.deployment) {
        var _projectSelect = this.$store.getters.project;
        this.$nextTick(function () {
          _this2.prjSelected = {
            id: _projectSelect.id_project,
            value: filters.project,
            label: _projectSelect.name || '',
            date_start: filters.date_from,
            date_end: filters.date_to,
            id_oceano: filters.location,
            deployments: _projectSelect.deployments
          };
          _this2.tableCaption = _projectSelect.name;
          _this2.$store.state.locationsBox = _this2.prjLocator.active = false;
          _this2.mygeojson();
          _this2.loadBoe('table');
          _this2.loadBoe('list');
        });
      } else if (filters.project) {
        this.prjLocator.active = true;
        this.prjLocator.location = this.project.location;
        this.$nextTick(function () {
          this.tableCaption = this.project.name;
          this.$store.state.locationsBox = true;
        });
      } else if (this.mapFilters.location) {
        this.$store.commit('SET_MAP_FILTERS', {
          location: filters.location || null,
          dateFrom: __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(30, 'days').format('YYYY-MM-DD'),
          dateTo: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD'),
          nationality: 'ITALY'
        });
        this.nationalitySelected = 'ITALY';
        this.mygeojson();
        this.loadBoe('table');
        this.loadBoe('list');
        this.$store.state.locationsBox = false;
      } else if (this.mapFilters.instrument) {
        this.nationalitySelected = 'ITALY';
        this.mapFilters.date_from = '1986-01-01';
        this.mapFilters.date_to = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
        this.$store.state.locationsBox = false;
        this.instrumentSelected = this.instrumentsFilter.filter(function (i) {
          return i.value.toString() === _this2.mapFilters.instrument.toString();
        })[0];
        this.mygeojson();
        this.loadBoe('table');
        this.loadBoe('list');
      }
    },
    loadLocator: function loadLocator(location, boe) {
      if (parseInt(boe, 10) === 0) return false;
      if (this.mapFilters.project) {
        this.$store.commit('SET_MAP_FILTERS', {
          location: location,
          type: ['drifter', 'float', 'glider'],
          dateFrom: this.project.date_start,
          dateTo: this.project.date_end_phy || __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD'),
          project: this.project.id_project
        });

        // set project form select
        this.prjSelected = {
          id: this.project.id_project,
          label: this.project.name || '',
          value: this.project.name || '',
          date_start: this.project.date_start,
          date_end: this.project.date_end_phy || __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD'),
          id_oceano: location
        };
        this.mygeojson();
        this.loadBoe('table');
        this.loadBoe('list');
        this.$store.state.locationsBox = false;
      } else {
        this.$store.commit('SET_MAP_FILTERS', {
          location: location,
          dateFrom: __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(30, 'days').format('YYYY-MM-DD'),
          dateTo: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD'),
          nationality: 'ITALY'
        });
        this.defaultLoc = this.locations.filter(function (l) {
          return parseInt(l.id, 10) === parseInt(location, 10);
        })[0];
        this.nationalitySelected = 'ITALY';
        this.mygeojson();
        this.loadBoe('table');
        this.loadBoe('list');
        this.$store.dispatch('LOAD_FILTER_PROJECT_LIST', this.parameters(this.mapFilters));
        this.$store.state.locationsBox = false;
      }
      this.chooseBaseMap();
    },
    mygeojson: function mygeojson() {
      var CLONE = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.mapFilters);
      this.tableCaption = this.prjSelected ? this.prjSelected.label : 'Selection';
      this.$store.dispatch('LOAD_MARKERS', this.parameters(CLONE));
    },
    onGeoJsonClick: function onGeoJsonClick(_ref) {
      var target = _ref.target;

      var table = this.tableView ? this.$refs.tableBonus : this.$refs.table;
      table.data.forEach(function (item) {
        item.selected = item.id_boa === target.feature.properties.id ? 'selected' : 'no-selected';
      });
    },
    popUpClose: function popUpClose(_ref2) {
      var target = _ref2.target;

      var table = this.tableView ? this.$refs.tableBonus : this.$refs.table;
      table.data.forEach(function (item) {
        if (item.id_boa === target.feature.properties.id) {
          item.selected = 'no-selected';
        }
      });
      // deselect checkbox trj
      if (target.feature.properties.delete) {
        this.trjId.splice(this.trjId.indexOf(target.feature.properties.id), 1);
      }
    },
    loadBoe: function loadBoe(type) {
      var CLONE = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.mapFilters);
      this.fromSelect = CLONE.date_from;
      this.toSelect = CLONE.date_to;
      this.$store.dispatch('LOAD_BOE_LIST', [this.parameters(CLONE), type]);
    },
    togglePanel: function togglePanel() {
      var _this3 = this;

      this.statusPanel = !this.statusPanel;
      if (this.statusPanel) {
        // remove resize map
        this.$el.querySelector('#map').setAttribute('style', 'height: 60%;max-height: calc(100% - 25px);');
        this.searchBoe();
      }
      setTimeout(function () {
        // trick to wait for height change
        _this3.paneresizestop();
        // this.$refs.map.mapObject.setZoom(this.$refs.map.mapObject.getZoom())
      }, 700);
    },
    searchBoe: function searchBoe() {
      if (this.statusPanel) {
        // this.loadBoe('count')
        this.disableSearch();
        this.mapFilters.instrument = null;
        this.instrumentSelected.label = null;
      }
    },
    filterType: function filterType() {
      this.$store.dispatch('LOAD_INSTRUMENTS_FILTER_LIST', this.parameters(this.mapFilters));
      this.boeListReset();
      this.searchBoe();
    },
    filterLocation: function filterLocation(location) {
      if (this.statusPanel) {
        if (location === null) {
          this.mapFilters.location = null;
          this.prjSelected = null;
        } else if (location.hasOwnProperty('id')) {
          this.mapFilters.location = location.id;
          if (!this.prjLocator.active) {
            this.prjSelected = null;
            this.mapFilters.date_from = '1986-01-01';
            this.mapFilters.date_to = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
          }
        }
        this.mapFilters.deployment = this.deploySelected = this.period = null;
        this.$store.dispatch('LOAD_FILTER_PROJECT_LIST', this.parameters(this.mapFilters));
        this.boeListReset();
        this.searchBoe();
      }
    },
    filterProjects: function filterProjects(project) {
      this.mapFilters.deployment = null;
      if (project === null) {
        this.prjLocator.active = false;
        this.mapFilters.project = null;
        this.mapFilters.date_from = '1986-01-01';
        this.mapFilters.date_to = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
        this.boeListReset();
        this.searchBoe();
      } else if (project.hasOwnProperty('id')) {
        if (parseInt(project.id, 10) !== parseInt(this.project.id_project, 10)) {
          this.prjLocator.active = false;
        }
        var location = this.$refs.locationsSelect.options.filter(function (l) {
          return parseInt(l.id, 10) === parseInt(project.id_oceano, 10);
        })[0];
        this.defaultLoc = location;
        this.mapFilters.location = project.id_oceano;
        this.mapFilters.project = project.id;
        this.mapFilters.date_from = project.date_start;
        this.mapFilters.date_to = project.date_end ? project.date_end : __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
        this.boeListReset();
        this.searchBoe();
        this.loadDeploySelect(project);
      }
      this.period = null;
      this.deploySelected = null;
    },
    loadDeploySelect: function loadDeploySelect(project) {
      if (project === null) {
        return false;
      }
      if (project.hasOwnProperty('deployments')) {
        this.deploy = project.deployments.map(function (item) {
          return {
            label: item.deploy.date ? item.deploy.date.toString() : 'undefined',
            value: item.deploy.id || 'undefined'
          };
        });
      }
    },
    filterProjectsDeploy: function filterProjectsDeploy(deploy) {
      if (deploy === null) {
        this.mapFilters.deployment = null;
      } else {
        this.mapFilters.deployment = deploy.value;
      }
      this.boeListReset();
      this.searchBoe();
    },
    filterInstruments: function filterInstruments(instruments) {
      if (instruments === null) {
        this.mapFilters.instrument = null;
      } else {
        this.mapFilters.instrument = instruments.value;
      }
      this.boeListReset();
      this.searchBoe();
    },
    filterNationality: function filterNationality(nationality) {
      if (this.statusPanel) {
        this.mapFilters.nationality = nationality;
        this.boeListReset();
        this.searchBoe();
      }
    },
    filterBoa: function filterBoa(boa) {
      if (boa && boa.length) {
        if (this.typeId === 'WMO') {
          this.mapFilters.wmo = boa.join();
        } else if (this.typeId === 'IMEI') {
          this.mapFilters.imei = boa.join();
        } else if (this.typeId === 'ID') {
          this.mapFilters.id = boa.join();
        }
        // this.loadBoe('list')
        this.searchBoe();
      } else if (!this.$store.state.locationsBox) {
        this.mapFilters.wmo = this.mapFilters.id = this.mapFilters.imei = null;
        // this.loadBoe('list')
        this.searchBoe();
      }
    },
    typeIdBoa: function typeIdBoa(type) {
      this.typeId = type;
      this.boeSelected = [];
      this.mapFilters.id = this.mapFilters.wmo = this.mapFilters.imei = null;
      this.filterBoa();
    },
    filterDateFrom: function filterDateFrom() {
      this.period = null;
      this.boeListReset();
      this.searchBoe();
    },
    filterDateTo: function filterDateTo() {
      this.period = null;
      this.boeListReset();
      this.searchBoe();
    },
    lastWeek: function lastWeek() {
      this.mapFilters.date_from = __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(7, 'days').format('YYYY-MM-DD');
      this.mapFilters.date_to = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
      this.boeListReset();
      this.searchBoe();
    },
    lastMonth: function lastMonth() {
      this.mapFilters.date_from = __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(30, 'days').format('YYYY-MM-DD');
      this.mapFilters.date_to = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
      this.boeListReset();
      this.searchBoe();
    },
    lastYear: function lastYear() {
      this.mapFilters.date_from = __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(365, 'days').format('YYYY-MM-DD');
      this.mapFilters.date_to = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
      this.boeListReset();
      this.searchBoe();
    },
    parameters: function parameters(f) {
      var str = '';
      for (var key in f) {
        if (str !== '') {
          str += '&';
        }
        str += key + '=' + f[key];
      }
      return str;
    },
    filterSearch: function filterSearch() {
      this.togglePanel();
      this.$store.commit('CLEAR_TRAJECTORIES');
      this.trjId = [];
      this.mygeojson();
      this.loadBoe('table');
      this.chooseBaseMap();
    },
    chooseBaseMap: function chooseBaseMap() {
      if (parseInt(this.mapFilters.location, 10) === 19) {
        this.antarcticMap();
      } else {
        this.defaultMap();
      }
    },
    boeListReset: function boeListReset() {
      if (this.statusPanel) {
        this.boeSelected = [];
        this.mapFilters.id = this.mapFilters.wmo = this.mapFilters.imei = null;
        this.loadBoe('list');
      }
    },
    filterReset: function filterReset() {
      this.period = null;
      this.$store.commit('RESET_MAP_FILTERS');
      this.typeInstrument = 'WMO';
      this.boeListReset();
      this.$refs.projectsSelect.clearSelection();
      this.$refs.locationsSelect.clearSelection();
      this.$refs.nationalitySelect.clearSelection();
    },
    onMapReady: function onMapReady() {
      var MAP = this.$refs.map.mapObject;
      MAP.removeControl(MAP.zoomControl);
      this.chooseBaseMap();
      MAP.on('click', function (e) {
        console.log('latlng', e.latlng);
        console.log('Bounds', MAP.getBounds());
      });
      __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.control.scale({
        imperial: false
      }).addTo(MAP);
      // this.flyTo()
      // add free draw tool
      // this.$refs.map.mapObject.addLayer(freeDraw)
    },
    flyTo: function flyTo() {
      var MAP = this.$refs.map.mapObject;
      var MARKERS = __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.geoJson(this.markers);
      if (MARKERS && '_northEast' in MARKERS.getBounds()) {
        MAP.flyToBounds(MARKERS.getBounds(), {
          paddingTopLeft: [0, 0]
        });
      }
    },
    zoomIn: function zoomIn() {
      this.$refs.map.mapObject.zoomIn();
    },
    zoomOut: function zoomOut() {
      this.$refs.map.mapObject.zoomOut();
    },
    defaultMap: function defaultMap() {
      this.extent = true;
      var MAP = this.$refs.map.mapObject;
      MAP.options.crs = __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.CRS.EPSG3857;
      this.bathyLayer.addTo(MAP);
      MAP.removeLayer(this.antarticaLayer);
      this.flyTo();

      MAP.options.minZoom = 2;
    },
    antarcticMap: function antarcticMap() {
      this.extent = false;
      var MAP = this.$refs.map.mapObject;

      MAP.options.crs = this.antarticCRS;

      this.bounds = __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.latLngBounds(__WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.latLng(1.6536767015385645, -110.59222150254793), __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.latLng(5.568379418956313, 71.29421299786227));

      this.antarticaLayer.addTo(MAP);
      MAP.removeLayer(this.bathyLayer);

      MAP.options.minZoom = 0;
    },
    viewMarker: function viewMarker(event, id) {
      var BOA = this.markers.features.filter(function (point) {
        return point.properties.id.toString() === id.toString();
      });
      if (BOA.length) {
        BOA[0].properties.selected = 'status-selected';
        var SELECTED = BOA.map(function (element) {
          return {
            lon: element.geometry.coordinates[0],
            lat: element.geometry.coordinates[1]
          };
        })[0];
        this.$refs.map.mapObject.flyTo(SELECTED, 9);
        // remove boa selected
        setTimeout(function () {
          BOA[0].properties.selected = 'no-selected';
        }, 12000);
      } else {
        console.log('No marker in the map!');
      }
    },
    getKml: function getKml(event, id, type) {
      var API = 'http://maosapi.inogs.it/v0.1/kml-all?' + type + '=' + id + '&single=true&type=' + type;
      window.location.href = API;
      /*
      axios.get(`http://maos.inogs.it/interfase/api/v0.1/kml-all?${type}=${id}&single=true&type=${type}`)
        .then(function (response) {
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
      */
    },
    getAllKml: function getAllKml(id) {
      var float = this.boe.filter(function (b) {
        return b.type === 'float';
      }).map(function (boa) {
        return boa.id_boa;
      }).toString() || null;

      var drifter = this.boe.filter(function (b) {
        return b.type === 'drifter';
      }).map(function (boa) {
        return boa.id_boa;
      }).toString() || null;
      // const glider = this.boe.filter(b => b.type === 'glider').map(boa => boa.id_boa.split(/\s*-\s*/)[0]).toString() || null

      var glider = this.boe.filter(function (b) {
        return b.type === 'glider';
      }).map(function (boa) {
        return boa.id_boa;
      }).toString() || null;

      var API = 'http://maosapi.inogs.it/v0.1/kml-all?float=' + float + '&drifter=' + drifter + '&glider=' + glider;

      console.log('All KML API ', API);
      window.location.href = API;
    },
    hiddenMarker: function hiddenMarker(event, type) {
      var ID = event.target.value.toString();
      var MARKERS = this.markers.features;
      var BOA = MARKERS.filter(function (point) {
        return point.properties.id.toString() === ID.toString();
      });
      if (event.target.checked) {
        BOA[0].properties.hidden = 'hidden';
      } else {
        BOA[0].properties.hidden = 'no-hidden';
      }
    },
    trjMarker: function trjMarker(event, type, id) {
      var _this4 = this;

      var ID = id.toString();
      if (event.target.checked) {
        this.$store.dispatch('LOAD_TRAJECTORY', 'type=' + type + '&id=' + ID + '&date_from=' + this.mapFilters.date_from + '&date_to=' + this.mapFilters.date_to).then(function (response) {
          var selected = response.data.features.filter(function (t) {
            return t.properties.id.toString() === ID;
          });
          var geojsonLayer = __WEBPACK_IMPORTED_MODULE_9_leaflet___default.a.geoJson(selected);
          if (_this4.mapFilters.location === 19) {
            return false;
          } else {
            _this4.$refs.map.mapObject.fitBounds(geojsonLayer.getBounds());
          }
        });
      } else {
        this.$store.commit('UNSET_TRAJECTORY', ID);
      }
    },
    hideAll: function hideAll(event) {
      if (event.target.checked) {
        var hiddenId = [];
        this.markers.features.forEach(function (m) {
          m.properties.hidden = 'hidden';
          hiddenId.push(m.properties.id);
        });
        this.hiddenId = hiddenId;
      } else {
        this.markers.features.forEach(function (m) {
          m.properties.hidden = 'no-hidden';
        });
        this.hiddenId = [];
      }
    },
    trjAll: function trjAll(event) {
      var _this5 = this;

      var breakLoop = false;
      if (event.target.checked) {
        var trjId = [];
        breakLoop = false;
        this.markers.features.some(function (m) {
          trjId.push(m.properties.id);
          _this5.$store.dispatch('LOAD_TRAJECTORY', 'type=' + m.properties.type + '&id=' + m.properties.id + '&date_from=' + _this5.mapFilters.date_from + '&date_to=' + _this5.mapFilters.date_to);
          // break when the callback returns true (@breakLoop)
          return breakLoop;
        });
        this.trjId = trjId;
      } else {
        breakLoop = true;
        this.trajectories.features = [];
        this.$store.commit('CLEAR_TRAJECTORIES');
        this.trjId = [];
      }
    },
    paneresizestop: function paneresizestop() {
      this.$refs.map.mapObject.invalidateSize();
    },
    tableType: function tableType() {
      this.tableView = !this.tableView;
    },
    disableSearch: function disableSearch() {
      if (this.boeSearchCount <= 0 || !this.mapFilters.date_from || !this.mapFilters.date_to || !this.loadedBoe) {
        return true;
      } else {
        return false;
      }
    },
    resetMapFilters: function resetMapFilters() {
      this.$store.commit('SET_MAP_FILTERS', {
        location: null,
        type: ['drifter', 'float', 'glider'],
        dateFrom: __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(3, 'days').format('YYYY-MM-DD'),
        dateTo: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD'),
        project: null,
        instrument: null,
        deployment: null
      });
      this.$store.state.locationsBox = true;
    },
    handleScroll: function handleScroll(event) {
      console.log('event', event);
    }
  },
  filters: {
    ddmmyyyyhmm: function ddmmyyyyhmm(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format('DD/MM/YYYY H:mm');
    },
    ddmmyyyy: function ddmmyyyy(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format('DD/MM/YYYY');
    }
  },
  destroyed: function destroyed() {
    if (this.boe.length === 0 || this.mapFilters.project !== null) {
      this.resetMapFilters();
    }
  }
});

/***/ }),

/***/ "tjnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__ = __webpack_require__("R1Vd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15f4465f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__ = __webpack_require__("F3oK");
function injectStyle (ssrContext) {
  __webpack_require__("6Jki")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15f4465f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15f4465f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vgCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("p4h2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037c986e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("jvIr");
function injectStyle (ssrContext) {
  __webpack_require__("Y7fe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-037c986e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037c986e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vu9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("/vj7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f42aef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("CP3g");
function injectStyle (ssrContext) {
  __webpack_require__("PFnb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51f42aef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f42aef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x7p7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__ = __webpack_require__("SVxk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0654de20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__ = __webpack_require__("BLQ2");
function injectStyle (ssrContext) {
  __webpack_require__("SD3Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0654de20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0654de20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  metaInfo: {
    title: 'Home',
    titleTemplate: '%s | Sistemi oceanografici mobili autonomi'
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['settings', 'home_data']),
  mounted: function mounted() {
    this.$store.dispatch('LOAD_SETTINGS');
    this.$store.dispatch('LOAD_HOME_DATA');
  }
});

/***/ }),

/***/ "xd4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_vimeo_player__ = __webpack_require__("SY33");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'instruments',
  metaInfo: {
    title: 'Instruments'
  },
  components: {
    'main-menu': __WEBPACK_IMPORTED_MODULE_1__components_MainMenu_vue__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"],
    'vimeo-player': __WEBPACK_IMPORTED_MODULE_4_vue_vimeo_player__["a" /* vueVimeoPlayer */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    settings: 'settings'
  }), {
    instrument: function instrument() {
      return this.$store.state.instruments;
    },
    type: function type() {
      return this.$route.params.type === 'drifters' ? 'drifter' : this.$route.params.type === 'floats' ? 'float' : 'glider';
    }
  }),
  data: function data() {
    return {
      msg: 'INSTRUMENTS',
      isOpen: false,
      title: this.$route.params.type,
      targets: ['drifters', 'floats', 'gliders'],
      overlay: {
        open: false,
        image: ''
      }
    };
  },

  watch: {
    '$route.params.type': function $routeParamsType(type) {
      if (this.targets.includes(type)) {
        this.upData();
      }
    }
  },
  methods: {
    upData: function upData() {
      if (this.targets.includes(this.$route.params.type)) {
        this.title = this.$route.params.type;
        this.$store.dispatch('LOAD_INSTRUMENTS_LIST', this.$route.params.type);
      } else {
        this.$router.push({ path: '/' });
      }
    },
    openDetails: function openDetails(item) {
      item.open = !item.open;
    },
    viewMap: function viewMap(id) {
      var _this = this;

      this.$store.dispatch('LOAD_INSTRUMENTS_FILTER_LIST', 'nationality=ITALY&type=' + this.type).then(function (response) {
        _this.$store.commit('SET_MAP_FILTERS', {
          type: [_this.type],
          instrument: id,
          dateFrom: null,
          dateTo: null,
          nationality: 'ITALY'
        });
        _this.$router.push({ path: '/data' });
      });
    },
    openOverlay: function openOverlay(slide) {
      this.overlay.open = true;
      this.overlay.image = slide.url;
    },
    closeOverlay: function closeOverlay() {
      this.overlay.open = false;
    },
    onReadyVideo: function onReadyVideo() {
      console.log('VIMEO ready');
    }
  },
  mounted: function mounted() {
    this.upData();
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.fbe411df2ca43618e419.js